!(function() {
   var B64={alphabet:"ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=",lookup:null,ie:/MSIE /.test(navigator.userAgent),ieo:/MSIE [67]/.test(navigator.userAgent),encode:function(a){var e,f,g,b=B64.toUtf8(a),c=-1,d=b.length,h=[,,];if(B64.ie){for(var i=[];++c<d;)e=b[c],f=b[++c],h[0]=e>>2,h[1]=(3&e)<<4|f>>4,isNaN(f)?h[2]=h[3]=64:(g=b[++c],h[2]=(15&f)<<2|g>>6,h[3]=isNaN(g)?64:63&g),i.push(B64.alphabet.charAt(h[0]),B64.alphabet.charAt(h[1]),B64.alphabet.charAt(h[2]),B64.alphabet.charAt(h[3]));return i.join("")}for(var i="";++c<d;)e=b[c],f=b[++c],h[0]=e>>2,h[1]=(3&e)<<4|f>>4,isNaN(f)?h[2]=h[3]=64:(g=b[++c],h[2]=(15&f)<<2|g>>6,h[3]=isNaN(g)?64:63&g),i+=B64.alphabet[h[0]]+B64.alphabet[h[1]]+B64.alphabet[h[2]]+B64.alphabet[h[3]];return i},decode:function(a){if(a.length%4)throw new Error("InvalidCharacterError: 'B64.decode' failed: The string to be decoded is not correctly encoded.");var b=B64.fromUtf8(a),c=0,d=b.length;if(B64.ieo){for(var e=[];d>c;)b[c]<128?e.push(String.fromCharCode(b[c++])):b[c]>191&&b[c]<224?e.push(String.fromCharCode((31&b[c++])<<6|63&b[c++])):e.push(String.fromCharCode((15&b[c++])<<12|(63&b[c++])<<6|63&b[c++]));return e.join("")}for(var e="";d>c;)e+=b[c]<128?String.fromCharCode(b[c++]):b[c]>191&&b[c]<224?String.fromCharCode((31&b[c++])<<6|63&b[c++]):String.fromCharCode((15&b[c++])<<12|(63&b[c++])<<6|63&b[c++]);return e},toUtf8:function(a){var d,b=-1,c=a.length,e=[];if(/^[\x00-\x7f]*$/.test(a))for(;++b<c;)e.push(a.charCodeAt(b));else for(;++b<c;)d=a.charCodeAt(b),128>d?e.push(d):2048>d?e.push(192|d>>6,128|63&d):e.push(224|d>>12,128|63&d>>6,128|63&d);return e},fromUtf8:function(a){var c,b=-1,d=[],e=[,,];if(!B64.lookup){for(c=B64.alphabet.length,B64.lookup={};++b<c;)B64.lookup[B64.alphabet.charAt(b)]=b;b=-1}for(c=a.length;++b<c&&(e[0]=B64.lookup[a.charAt(b)],e[1]=B64.lookup[a.charAt(++b)],d.push(e[0]<<2|e[1]>>4),e[2]=B64.lookup[a.charAt(++b)],64!=e[2])&&(d.push((15&e[1])<<4|e[2]>>2),e[3]=B64.lookup[a.charAt(++b)],64!=e[3]);)d.push((3&e[2])<<6|e[3]);return d}};
    //Add_storeify_data
    var appParams = JSON.parse(B64.decode(storeify_requestaquote));
    var config_reponse = appParams.settings;
    var shippingQuote = appParams.shipping;
    var frmParams = appParams.frm_params;
    // console.log(config_reponse.check_cache);console.log('mode-0');
    if (config_reponse.status == '0') return;
    var loadScript=function(url,callback){var script=document.createElement("script");script.type="text/javascript";if(script.readyState){script.onreadystatechange=function(){if(script.readyState=="loaded"||script.readyState=="complete"){script.onreadystatechange=null;callback()}}}else{script.onload=function(){callback()}}script.src=url;document.getElementsByTagName("head")[0].appendChild(script)};
    var storeifyJavaScript = function(jQuery) {
        var meta = '';
        if (window.meta) {
            meta = window.meta.page;
        }

        var domainname = '';
        if (typeof Shopify !== 'undefined') {
            domainname = Shopify.shop;
        }

        var max_file = 5;
        var file_size = 5120;
        var html_before = '';
        var html_after = '';
        var array_remove_price = config_reponse.ele_price_remove; //[ '.price','.product-item__price-wrapper','.grid-product__price-wrap','.grid-link__meta','.card__price','.price__sale','.product-item--price','.price--on-sale','.product-card__price','.product-single__meta-list','.product__price'];
        var array_remove_btn = config_reponse.ele_btn_remove;
        var ele_frm_detail = config_reponse.ele_frm_detail;
        var remove_ele_custom = config_reponse.ele_remove;
        var array_ele_qty_remove = config_reponse.ele_qty_remove;
        var ele_itemList = config_reponse.ele_item_list; //'.grid__item';
        var storeify_lang = config_reponse.lang;
        var appConfig = window.storeifyRequestaquote || {};
        var requestaquote_json = appConfig.storeify_requestaquote_json;
        var show_qty_modal = config_reponse.show_qty;
        var variant_element = appConfig.variant_element;// thêm config vào header
        var ify_variant_url = appConfig.variant_url || true;
        var qty_element = '';
        var ify_short_code = config_reponse.short_code;
        var ify_show_input_price = appConfig.show_input_price;
        if (typeof appConfig.lang !== 'undefined') {
            storeify_lang = appConfig.lang;
        }
        var root_url = '/';
        if (appConfig.root_url && appConfig.root_url != '/') root_url = appConfig.root_url + '/';

        var validateMesLangIfy = {};
        var langOtherIfy = {};
        var ify_minQty = typeof config_reponse.min_qty !== 'undefined' ? config_reponse.min_qty : 1;
        var ify_maxQty = typeof config_reponse.max_qty !== 'undefined' ? config_reponse.max_qty : '';
        var lang_qty_min = typeof storeify_lang.min_qty !== 'undefined' && storeify_lang.min_qty !== null ?  storeify_lang.min_qty : 'Minimum quantity is {0}.';
            lang_qty_min = lang_qty_min.replace("{0}", ify_minQty);
        var lang_qty_max = typeof storeify_lang.max_qty !== 'undefined' && storeify_lang.max_qty !== null ?  storeify_lang.max_qty : 'Maximum quantity is {0}.';
            lang_qty_max = lang_qty_max.replace("{0}", ify_maxQty);
        // .storeify-hiden-price

        jQuery('body').addClass('storeify-hiden-price');
        let login_see_btn = '';
        if (config_reponse.login_see == 1 && (typeof appConfig.customer == 'undefined')) {
            config_reponse.remove_price = 1;
            config_reponse.remove_button = 1;
            ify_show_input_price = 0;
            login_see_btn = '<a href="/account" class="storeify-quote-see-price btn button">' + storeify_lang.btn_see_price + '</a><div class="ify-clear-fix"></div>';
            let loginRj = document.referrer;
            if (typeof loginRj !== 'undefined') {
                jQuery('#customer_login,form[action="' + root_url + 'account/login"]').append('<input type="hidden" name="checkout_url" value="' + loginRj + '">');
            }
        }
        if (config_reponse.login_see == 1 && (typeof appConfig.customer != 'undefined')) {
            config_reponse.remove_price = 0;
        }
        setTimeout(function() {
            jQuery('#ify-style-remove').remove();
        }, 500);

        function jviewFormbuilder(id, html, upload, max, storeify_filezie,shippingQuote={}) {
            jQuery(document).ready(function() {

                jQuery('body').append(html);
                initIntlTelInputForStoreify('#storeify_form_action_' + id);
                jQuery('.storeify_money_format').val(appConfig.money_format);
                jQuery('.storeify_currency').val(window.ShopifyAnalytics.meta.currency);
                jQuery('.storeify_country_code').val(window.Shopify.country);
                jQuery('.storeify_localization').val(appConfig.locale);
                jQuery('.ify-shippings-json').val(JSON.stringify(shippingQuote));
                if (typeof appConfig.customer !== 'undefined') {
                    jQuery('.storeify-form-action-quote input[name="storeifyInput_first_name"]').val(appConfig.customer.first_name);
                    jQuery('.storeify-form-action-quote input[name="storeifyInput_last_name"]').val(appConfig.customer.last_name);
                    jQuery('.storeify-form-action-quote input[name="storeifyInput_email"]').val(appConfig.customer.email);
                    jQuery('.storeify-requestaquote input[name="customer"]').val(appConfig.customer.id);
                    jQuery('.storeify-requestaquote input[name="storeify_default_address"]').val(JSON.stringify(appConfig.customer.default_address));
                }

                let ify_upload_label = upload.upload_label;
                if(Object.keys(langOtherIfy).length !== 0 && typeof langOtherIfy[id][appConfig.locale] !== 'undefined'){
                    const langOtherIfy_1 = langOtherIfy[id][appConfig.locale];
                    if(typeof langOtherIfy_1['title'] !== 'undefined' && typeof langOtherIfy_1['title'] !== ''){
                        jQuery(`#storeify_form_action_${id} .storeify-title-frm`).html(langOtherIfy_1['title']);
                        jQuery(`#storeify_form_action_${id} .title-frm-hide`).val(langOtherIfy_1['title']);
                    }
                    if(typeof langOtherIfy_1['sub_title'] !== 'undefined' && typeof langOtherIfy_1['sub_title'] !== '')
                        jQuery(`#storeify_form_action_${id} .storeify-sub-title-frm`).html(langOtherIfy_1['sub_title']);
                    if(typeof langOtherIfy_1['submit_button'] !== 'undefined' && typeof langOtherIfy_1['submit_button'] !== '')
                        jQuery(`#storeify_form_action_${id} .storeify-submit-frm`).text(langOtherIfy_1['submit_button']);
                    if(typeof langOtherIfy_1['attachfile_text'] !== 'undefined' && typeof langOtherIfy_1['attachfile_text'] !== '')
                        ify_upload_label =  langOtherIfy_1['attachfile_text'];

                }
                if (upload.upload == 1)
                    uploadFile(id, ify_upload_label, upload.upload_url, max, storeify_filezie);
            });
        }
        var formatMoney = function(cents, format) {
            if (typeof cents == 'string') {
                cents = cents.replace('.', '');
            }
            var value = '';
            var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
            var formatString = (format || this.money_format);

            function defaultOption(opt, def) {
                //console.log('opt' + opt + '--' + 'def' + def);
                return (typeof opt == 'undefined' ? def : opt);
            }

            function formatWithDelimiters(number, precision, thousands, decimal) {
                precision = defaultOption(precision, 2);
                thousands = defaultOption(thousands, ',');
                decimal = defaultOption(decimal, '.');

                if (isNaN(number) || number == null) {
                    return 0;
                }

                number = (number / 100.0).toFixed(precision);
                //console.log('number--' + number);
                var parts = number.split('.'),
                    dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
                    cents = parts[1] ? (decimal + parts[1]) : '';

                return dollars + cents;
            }

            switch (formatString.match(placeholderRegex)[1]) {
                case 'amount':
                    value = formatWithDelimiters(cents, 2);
                    break;
                case 'amount_no_decimals':
                    value = formatWithDelimiters(cents, 0);
                    break;
                case 'amount_with_comma_separator':
                    value = formatWithDelimiters(cents, 2, '.', ',');
                    break;
                case 'amount_no_decimals_with_comma_separator':
                    value = formatWithDelimiters(cents, 0, '.', ',');
                    break;
            }

            return formatString.replace(placeholderRegex, value);
        }; //end money
        function checkConditionRate(val,w = 0, p = 0,shopifyRate = 1){
            if(!val.rate_condition_check || val.rate_condition_check == "0"){
               return 1;   
            }else{
                if(val.rate_condition == "1"){
                    //console.log(Number(val.rate_price_min)*shopifyRate);console.log(Number(val.rate_price_max)*shopifyRate);console.log(p);
                    //console.log(val.rate_price_min != 'null' && val.rate_price_max != 'null' && Number(val.rate_price_min)*shopifyRate <= p && Number(val.rate_price_max)*shopifyRate >= p);
                    if(val.rate_price_min == 'null' && val.rate_price_max == 'null') return 1;
                    if(val.rate_price_min == 'null' && val.rate_price_max != 'null' && Number(val.rate_price_max)*shopifyRate >= p) return 1;
                    if(val.rate_price_min != 'null' && val.rate_price_max == 'null' && Number(val.rate_price_min)*shopifyRate <= p) return 1;
                    if(val.rate_price_min != 'null' && val.rate_price_max != 'null' && Number(val.rate_price_min)*shopifyRate <= p && Number(val.rate_price_max)*shopifyRate >= p) return 1;
                }
                if(val.rate_condition == "2"){
                    if(val.rate_weight_min == 'null' && val.rate_weight_max == 'null') return 1;
                    if(val.rate_weight_min == 'null' && val.rate_weight_max != 'null' && Number(val.rate_weight_max) >= w) return 1;
                    if(val.rate_weight_min != 'null' && val.rate_weight_max == 'null' && Number(val.rate_weight_min) <= w) return 1;
                    if(val.rate_weight_min != 'null' && val.rate_weight_max != 'null' && Number(val.rate_weight_min) <= w && Number(val.rate_weight_max) >= w ) return 1;
                }
            }
            return 0;
        }
        function renderShippings(shippingQuote,w = 0, p = 0){
            let htmlShiping = '';
            let dem = 0;
            let shopifyRate = 1;
            if(window.Shopify && window.Shopify.currency){
                shopifyRate = Number(window.Shopify.currency.rate);
            }
            jQuery.each(shippingQuote, function(key, value) {
                let rate = value;
                if(typeof value == 'string') rate = JSON.parse(value);
                if(checkConditionRate(rate,w,p,shopifyRate) == 1){
                    htmlShiping += '<div class="ify-item-rate ify-item-rate-'+dem+'">';
                    htmlShiping += '    <div class="ify-shipping-line">';
                    htmlShiping += '        <div class="ify-shipping-line-flex">';
                    htmlShiping += '            <label class="ify-shipping-label">';
                    if(dem == 0)
                        htmlShiping += '                <input type="radio" name="shipping_radio" value="'+rate.id+'" class="ify-shipping-radio" checked="checked">';
                    else
                        htmlShiping += '                <input type="radio" name="shipping_radio" value="'+rate.id+'" class="ify-shipping-radio" >';
                    let shipping_sub = '';
                    if(rate.rate_des && rate.rate_des != 'null')
                        shipping_sub = '<span class="ify-shipping-description">'+rate.rate_des+'</span>';
                    htmlShiping += '                <div class="ify-shipping-flex-column" ><span class="ify-shipping-name">'+rate.rate_name+'</span>'+shipping_sub;
                    htmlShiping += '                </div>';
                    htmlShiping += '            </label>';
                    htmlShiping += '        </div>';
                    let shipping_price = "Free";
                    if(typeof storeify_lang.free != 'undefined' && storeify_lang.free != null) shipping_price = storeify_lang.free;
                    if(Number(rate.rate_amout) != 0) shipping_price = formatMoney(Number(rate.rate_amout)*shopifyRate*100, appConfig.money_format);
                    htmlShiping += '        <div class="ify-shipping-price" ><span>'+shipping_price+'</span>';
                    htmlShiping += '        </div>';
                    htmlShiping += '    </div>';
                    htmlShiping += '</div>';
                    dem++;
                }
            });
            let shipping_options = 'Shipping Options';
            if(typeof storeify_lang.shipping_options != 'undefined' && storeify_lang.shipping_options != null) shipping_options = storeify_lang.shipping_options;
            if(htmlShiping != '') htmlShiping = '<div class="ify-shipping-title">'+shipping_options+'</div><div class="ify-shippings">'+htmlShiping+'<input type="hidden" name="shopify_rate" value="'+shopifyRate+'"></div>';

            return htmlShiping;
        }
        function uploadFile(id, label, url, max, storeify_filezie) {
            var $storeify_files = jQuery("#storeify_form_attach_file_" + id);
            var storeify_time = new Date().getTime();
            let msgSizeTooLarge = storeify_lang.msg_size_attach ? storeify_lang.msg_size_attach : 'Files "{name}" ({size}) exceeds maximum allowed upload size of {maxSize}.';
            let msgFilesTooLess = storeify_lang.msg_attach_tooless ? storeify_lang.msg_attach_tooless : 'You must select at least {n} {files} to upload. Please retry your upload!';
            let msgCalculatingTime = storeify_lang.msg_calculating_time ? storeify_lang.msg_calculating_time : 'calculating time remaining';
            let msgUploadThreshold = storeify_lang.msg_processing ? storeify_lang.msg_processing : 'Processing ...';

            $storeify_files.fileinput({
                allowedFileExtensions: ['jpg', 'gif', 'png', 'jpeg', 'tiff', 'txt', 'mp3', 'mp4', 'zip', 'doc', 'docx', 'csv', 'xls', 'xlsx', 'ppt', 'pdf', 'psd', 'svg', 'esp', 'ai'],
                uploadUrl: url,
                uploadAsync: true,
                showPreview: false,
                showCaption: false,
                showCancel: false,
                showRemove: false,
                showUpload: false, // hide upload button
                showRemove: false, // hide remove button
                browseIcon: '<i class="fa fa-paperclip"> </i>',
                browseLabel: label,
                browseClass: 'btn-ctf-attach',
                removeLabel: '',
                removeClass: 'btn btn-ctf-remove-attach form-control',
                uploadLabel: '',
                uploadClass: 'btn btn-ctf-upload-attach form-control',
                msgInvalidFileExtension: 'Only "{extensions}" files are supported.',
                overwriteInitial: false, // append files to initial preview
                minFileCount: 1,
                maxFileCount: max,
                maxFileSize: storeify_filezie, //5Mb(5120)
                msgSizeTooLarge: msgSizeTooLarge,
                msgFilesTooLess: msgFilesTooLess,
                msgCalculatingTime:msgCalculatingTime,
                msgUploadThreshold:msgUploadThreshold,
                theme: 'fa',
                initialPreviewAsData: true,
                elErrorContainer: '#form_attach_file_error_' + id,
                uploadExtraData: function() {
                    return {
                        _token: jQuery("#storeify_form_action_" + id + " input[name='_token']").val(),
                        id: id,
                        shopify_domain: window.Shopify.shop,
                    };
                },
                slugCallback: function(filename) {
                    filename = filename.replace('(', '_').replace(']', '_').replace(')', '_').replace(' ', '_').split();
                    filename = storeify_time + '_' + filename;
                    jQuery('#storeify_attach_filename_temp_' + id).val('storeify_v2');
                    // jQuery('#storeify_form_attach_filename_'+id).val(filename);
                    return filename;
                }
            }).on("filebatchselected", function(event, files) {
                // $storeify_files.fileinput("upload");
                jQuery(event.target).fileinput("upload");
            }).on('filebatchpreupload', function(event, data, id, index) {

                var ele_id = data.extra.id;
                var string_name = jQuery('#storeify_form_attach_filename_' + ele_id).val();
                jQuery('#storeify_content_formbuilder_' + ele_id).addClass('storeify-frm-loading');
                if (string_name == '')
                    jQuery('#form_attach_file_success_' + ele_id).html('<ul></ul>').hide();

            }).on('fileuploaded', function(event, data, id, index) {
                var out = '';
                var ar_name = [];
                var ar_label = [];
                var ele_id = data.extra.id;
                var fname = data.response.name;//data.files[index].name;
                var pathF = data.response.path;
                let upload_li_success = storeify_lang.upload_li_success ? storeify_lang.upload_li_success : 'Uploaded file "{name}" Successfully.';
                let upload_li_fail = storeify_lang.upload_li_fail ? storeify_lang.upload_li_fail : 'Uploaded file "{name}" Fail.';


                if (data.response.type == 'success') {
                    var string_name = jQuery('#storeify_form_attach_filename_' + ele_id).val() + ',' + pathF;
                    jQuery('#storeify_form_attach_filename_' + ele_id).val(string_name);
                    var li_item = '<li class="storeify-contact-img" data-id="' + ele_id + '" data-name="' + pathF.replace(/"/g, '&quot;') + '"><i class="fa fa-file-o"></i> ' + upload_li_success.replace('{name}', fname) + ' <i style="font-size:14px;color:red;cursor: pointer;" class="fa fa-times storeify-delete-file" aria-hidden="true" title="Remove"></i></li>';
                } else {
                    var li_item = '<li class="storeify-contact-img" data-id="' + ele_id + '"><i class="fa fa-file-o"></i> ' + upload_li_fail.replace('{name}', fname) + ' <i style="font-size:14px;color:red;cursor: pointer;" class="fa fa-times storeify-delete-file" aria-hidden="true" title="Remove"></i></li>';
                }
                jQuery('#form_attach_file_success_' + ele_id + ' ul').append(li_item);
                jQuery('#form_attach_file_success_' + ele_id).fadeIn('slow');

                $storeify_files.removeAttr('required');
                jQuery('#storeify_form_action_' + ele_id + ' .kv-upload-progress').hide();
                jQuery('#storeify_content_formbuilder_' + ele_id).removeClass('storeify-frm-loading');
                if (jQuery('#storeify_form_attach_filename_' + ele_id + '-error').length) jQuery('#storeify_form_attach_filename_' + ele_id + '-error').remove();
            });
            
            jQuery(document).on("click", ".storeify-contact-img .storeify-delete-file", function(e) {
                var ele_id = jQuery(this).parent().attr('data-id');
                var val = jQuery(this).parent().attr('data-name');
                var attach_submit = jQuery('#storeify_form_attach_filename_' + ele_id).val();
                jQuery('#storeify_form_attach_filename_' + ele_id).val(attach_submit.replace(',' + val, ''));
                jQuery(this).parent().remove();
                var child = jQuery('#form_attach_file_success_' + ele_id + ' ul li').length;
                if (child == 0) jQuery('#form_attach_file_success_' + ele_id).hide();
            });
        }

        function removeFromlistingpage(closest, parent, array) {
            var parentItem = closest.closest(parent.trim());
            if (parentItem.length > 0) {
                parentItem.find(array.trim()).remove();
                return;
            }

            var recommendationItem = closest.closest('product-recommendations .slider__item, product-recommendations li, .product-recommendations .slider__item, .product-recommendations li');
            if (recommendationItem.length > 0) {
                recommendationItem.find(array.trim()).remove();
            }
        }

        function removeFromdetailpage(array, parent) {
            jQuery(parent).find(array.trim()).remove();
        }

        function getUtmSource(){
            let queryString = window.location.search;
            let urlParams = new URLSearchParams(queryString);
            let utm_source = urlParams.get('utm_source');
            if(utm_source == null) return '';
            return utm_source;
        }
        function findProducts(productobj, id, meta, ele_itemList, array_remove_price, array_remove_btn, array_ele_qty_remove, ele_frm_detail) {

            jQuery("a[href*='/products']").each(function() {
                currHref = $(this);
                var getlistUrl = currHref.attr('href');
                getlistUrlSub = getlistUrl.substring(getlistUrl.lastIndexOf('/') + 1);
                sort_url = getlistUrlSub.split("?")[0];
                if ($.inArray(sort_url, productobj) !== -1) {
                    var parentItem = currHref.closest(ele_itemList.trim());
                    if (!parentItem.hasClass('ify-has-modal')) {
                        parentItem.addClass('ify-has-modal').append('<div class="storeify-request-bnt storeify-request-bnt-list"><button type="button"  id="storeify-trigger-popup-' + id + '"  class="storeify-quote-btn-trigger-popup btn button button--primary call-for-price-btn"  id="storeify-trigger-popup-' + id + '" data-product="' + sort_url + '"  data-id="' + id + '" aria-haspopup="dialog" aria-expanded="false" aria-controls="storeify-light-modal-' + id + '" data-target="#storeify-light-modal-' + id + '">' + storeify_lang.call_for_price + '</button></div><br>');
                    }
                    if (config_reponse.remove_price == 1)
                        removeFromlistingpage(currHref, ele_itemList, array_remove_price);
                    if (config_reponse.remove_button == 1)
                        removeFromlistingpage(currHref, ele_itemList, array_remove_btn)
                }
            });
            if ((meta.pageType == 'product' && typeof meta.resourceId !== 'undefined') || (appConfig.page.type == 'product')) {

                var sort_url = appConfig.product.handle;
                if ($.inArray(sort_url, productobj) !== -1) {
                    if (jQuery('.storeify-button-quote-liquid').length > 0) {
                        if (!jQuery('.storeify-button-quote-liquid').hasClass('ify-has-modal'))
                            jQuery('.storeify-button-quote-liquid').removeClass('ify-hide').addClass('ify-has-modal').attr('data-id', id).attr('data-product', sort_url).attr('data-target', '#storeify-light-modal-' + id).attr('aria-controls','storeify-light-modal-' + id)
                    } else {
                        jQuery(ele_frm_detail).find('form[action=\"' + root_url + 'cart/add\"]').find('button[type="submit"]').eq(0).after(jQuery('<div class="storeify-request-bnt storeify-request-bnt-detail" ><button type="button"  id="storeify-trigger-popup-' + id + '"  class="storeify-quote-btn-trigger-popup btn button button--primary call-for-price-btn"  id="storeify-trigger-popup-' + id + '" data-product="' + sort_url + '"  data-id="' + id + '" aria-haspopup="dialog" aria-expanded="false" aria-controls="storeify-light-modal-' + id + '" data-target="#storeify-light-modal-' + id + '">' + storeify_lang.call_for_price + '</button></div>'));
                    }
                    if (config_reponse.remove_price == 1)
                        removeFromdetailpage(array_remove_price, ele_frm_detail);
                    if (config_reponse.remove_button == 1) {
                        removeFromdetailpage(array_ele_qty_remove, ele_frm_detail);
                        removeFromdetailpage(array_remove_btn, ele_frm_detail);
                    }
                }
            }

        }

        function findProductscode(productobj, id, meta, ele_itemList, array_remove_price, array_remove_btn, array_ele_qty_remove, ele_frm_detail) {

            jQuery(".ify-button-code").each(function() {
                currHref = $(this);
                var sort_url = currHref.attr('data-product');
                if ($.inArray(sort_url, productobj) !== -1) {
                    var parentItem = currHref.closest(ele_itemList.trim());
                    if ((meta.pageType == 'product' && typeof meta.resourceId !== 'undefined') || (appConfig.page.type == 'product')) {
                        if (!currHref.hasClass('ify-has-modal')) {
                            currHref.removeClass('ify-hide').addClass('storeify-button-detail ify-has-modal').attr('data-id', id).attr('data-target', '#storeify-light-modal-' + id).attr('aria-controls','storeify-light-modal-' + id).attr('aria-haspopup','dialog').attr('aria-expanded','false');
                            currHref.parent().addClass('storeify-request-bnt-detail');
                        }
                        if (config_reponse.remove_price == 1)
                            removeFromdetailpage(array_remove_price, ele_frm_detail);
                        if (config_reponse.remove_button == 1) {
                            removeFromdetailpage(array_ele_qty_remove, ele_frm_detail);
                            removeFromdetailpage(array_remove_btn, ele_frm_detail);
                        }
                    } else {
                        var parentItem = currHref.closest(ele_itemList.trim());
                        if (!currHref.hasClass('ify-has-modal')) {
                            currHref.removeClass('ify-hide').addClass('storeify-button-grid ify-has-modal').attr('data-id', id).attr('data-target', '#storeify-light-modal-' + id).attr('aria-controls','storeify-light-modal-' + id).attr('aria-haspopup','dialog').attr('aria-expanded','false');
                        }
                        if (config_reponse.remove_price == 1)
                            removeFromlistingpage(currHref, ele_itemList, array_remove_price);
                        if (config_reponse.remove_button == 1)
                            removeFromlistingpage(currHref, ele_itemList, array_remove_btn);
                    }
                }
            });

        }

        function allProducts(productobj, id, meta, ele_itemList, array_remove_price, array_remove_btn, array_ele_qty_remove, ele_frm_detail) {

            jQuery("a[href*='/products']").each(function() {
                currHref = jQuery(this);
                var getlistUrl = currHref.attr('href');
                getlistUrlSub = getlistUrl.substring(getlistUrl.lastIndexOf('/') + 1);
                var sort_url = getlistUrlSub.split("?")[0];
                // jQuery(this).parent().find('.price').after('<div class="storeify-request-bnt" style="text-align: center;"><button type="button"  id="storeify-trigger-popup-'+id+'"  class="storeify-quote-btn-trigger-popup btn button button--primary call-for-price-btn"  id="storeify-trigger-popup-'+id+'" data-product="'+getlistUrl+'"  data-id="'+id+'" data-target="#storeify-light-modal-'+id+'">Call for price</button></div><br>'); 
                var parentItem = currHref.closest(ele_itemList.trim());
                if (!parentItem.hasClass('ify-has-modal')) {
                    parentItem.addClass('ify-has-modal').append('<div class="storeify-request-bnt storeify-request-list"><button type="button"  id="storeify-trigger-popup-' + id + '"  class="storeify-quote-btn-trigger-popup btn button button--primary call-for-price-btn"  id="storeify-trigger-popup-' + id + '" data-product="' + sort_url + '"  data-id="' + id + '" aria-haspopup="dialog" aria-expanded="false" aria-controls="storeify-light-modal-' + id + '" data-target="#storeify-light-modal-' + id + '">' + storeify_lang.call_for_price + '</button></div>');
                }
                if (config_reponse.remove_price == 1)
                    removeFromlistingpage(currHref, ele_itemList, array_remove_price);
                if (config_reponse.remove_button == 1)
                    removeFromlistingpage(currHref, ele_itemList, array_remove_btn)

            });
            if ((meta.pageType == 'product' && typeof meta.resourceId !== 'undefined') || (appConfig.page.type == 'product')) {
                var getlistUrl = appConfig.product.handle;
                if (jQuery('.storeify-button-quote-liquid').length > 0) {
                    if (!jQuery('.storeify-button-quote-liquid').hasClass('ify-has-modal'))
                        jQuery('.storeify-button-quote-liquid').removeClass('ify-hide').addClass('ify-has-modal').attr('data-id', id).attr('data-product', getlistUrl).attr('data-target', '#storeify-light-modal-' + id)
                } else {
                    jQuery(ele_frm_detail).find('form[action=\"' + root_url + 'cart/add\"]').find('button[type="submit"]').eq(0).after('<div class="storeify-request-bnt storeify-request-bnt-detail" ><button type="button"  id="storeify-trigger-popup-' + id + '"  class="storeify-quote-btn-trigger-popup btn button button--primary call-for-price-btn"  id="storeify-trigger-popup-' + id + '" data-product="' + getlistUrl + '"  data-id="' + id + '" aria-haspopup="dialog" aria-expanded="false" aria-controls="storeify-light-modal-' + id + '" data-target="#storeify-light-modal-' + id + '">' + storeify_lang.call_for_price + '</button></div>');
                }
                if (config_reponse.remove_price == 1)
                    removeFromdetailpage(array_remove_price, ele_frm_detail);
                if (config_reponse.remove_button == 1) {
                    removeFromdetailpage(array_ele_qty_remove, ele_frm_detail);
                    removeFromdetailpage(array_remove_btn, ele_frm_detail);
                }


            }

        }

        function allProductscode(productobj, id, meta, ele_itemList, array_remove_price, array_remove_btn, array_ele_qty_remove, ele_frm_detail) {

            jQuery(".ify-button-code").each(function() {
                currHref = $(this);
                var sort_url = currHref.attr('data-product');
                // if($.inArray(sort_url, productobj) !== -1){
                if ((meta.pageType == 'product' && typeof meta.resourceId !== 'undefined') || (appConfig.page.type == 'product')) {
                    if (!currHref.hasClass('ify-has-modal')) {
                        currHref.removeClass('ify-hide').addClass('storeify-button-detail ify-has-modal').attr('data-id', id).attr('data-target', '#storeify-light-modal-' + id);
                        currHref.parent().addClass('storeify-request-bnt-detail');
                    }
                    if (config_reponse.remove_price == 1)
                        removeFromdetailpage(array_remove_price, ele_frm_detail);
                    if (config_reponse.remove_button == 1) {
                        removeFromdetailpage(array_ele_qty_remove, ele_frm_detail);
                        removeFromdetailpage(array_remove_btn, ele_frm_detail);
                    }
                } else {
                    var parentItem = currHref.closest(ele_itemList.trim());
                    if (!currHref.hasClass('ify-has-modal'))
                        currHref.removeClass('ify-hide').addClass('storeify-button-grid ify-has-modal').attr('data-id', id).attr('data-target', '#storeify-light-modal-' + id);
                    if (config_reponse.remove_price == 1)
                        removeFromlistingpage(currHref, ele_itemList, array_remove_price);
                    if (config_reponse.remove_button == 1)
                        removeFromlistingpage(currHref, ele_itemList, array_remove_btn);
                }
                // }
            });

        }

        function checkConditionsOr(condition_key, condition_name, condition_val, productData, collectionData) {
            var check = 0 //mode = all;
            jQuery.each(condition_key, function(index, value) {
                if (value == 'type' || value == 'vendor') {
                    if (condition_name[index] == 'equal') {
                        if (productData[value] == condition_val[index]) return check = 1;
                    }
                    if (condition_name[index] == 'not_equal') {
                        if (productData[value] != condition_val[index]) return check = 1;
                    }
                    if (condition_name[index] == 'contains') {
                        if (productData[value].toLowerCase().indexOf(condition_val[index]) >= 0) return check = 1;
                    }
                    if (condition_name[index] == 'not_contains') {
                        if (productData[value].toLowerCase().indexOf(condition_val[index]) == -1) return check = 1;
                    }
                    if (condition_name[index] == 'starts_with') {
                        if (productData[value].startsWith(condition_val[index])) return check = 1;
                    }
                    if (condition_name[index] == 'ends_with') {
                        if (productData[value].endsWith(condition_val[index])) return check = 1;
                    }
                }
                if (value == 'available') {
                    if (condition_val[index] == 'no') {
                        if (productData[value]) return check = 1;
                    } else {
                        if (!productData[value]) return check = 1;
                    }
                }
                if (value == 'tags') {
                    if (condition_name[index] == 'equal') {
                        if (jQuery.inArray(condition_val[index], productData.tags) !== -1) return check = 1;
                    }
                    if (condition_name[index] == 'not_equal') {
                        if (jQuery.inArray(condition_val[index], productData.tags) == -1) return check = 1;
                    }
                }
                if (value == 'collection') {
                    let collectionJson = JSON.parse(condition_val[index]);
                    if (condition_name[index] == 'equal') {
                        if (jQuery.inArray(Number(collectionJson.id), collectionData) !== -1) return check = 1;
                    }
                    if (condition_name[index] == 'not_equal') {
                        if (jQuery.inArray(Number(collectionJson.id), collectionData) == -1) return check = 1;
                    }
                }
                if (value == 'price') {
                    if (condition_name[index] == 'equal') {
                        if (productData[value] == Number(condition_val[index]) * 100) return check = 1;
                    }
                    if (condition_name[index] == 'not_equal') {
                        if (productData[value] != Number(condition_val[index]) * 100) return check = 1;
                    }
                    if (condition_name[index] == 'greater') {
                        if (productData[value] > Number(condition_val[index]) * 100) return check = 1;
                    }
                    if (condition_name[index] == 'less') {
                        if (productData[value] < Number(condition_val[index]) * 100) return check = 1;
                    }
                }
            });
            return check;
        }

        function checkConditionsAnd(condition_key, condition_name, condition_val, productData, collectionData) {
            var check = 1 //mode = all;
            jQuery.each(condition_key, function(index, value) {
                if (value == 'type' || value == 'vendor') {
                    if (condition_name[index] == 'equal') {
                        if (productData[value] != condition_val[index]) return check = 0;
                    }
                    if (condition_name[index] == 'not_equal') {
                        if (productData[value] == condition_val[index]) return check = 0;
                    }
                    if (condition_name[index] == 'contains') {
                        if (productData[value].toLowerCase().indexOf(condition_val[index]) == -1) return check = 0;
                    }
                    if (condition_name[index] == 'not_contains') {
                        if (productData[value].toLowerCase().indexOf(condition_val[index]) >= 0) return check = 0;
                    }
                    if (condition_name[index] == 'starts_with') {
                        if (!productData[value].startsWith(condition_val[index])) return check = 0;
                    }
                    if (condition_name[index] == 'ends_with') {
                        if (!productData[value].endsWith(condition_val[index])) return check = 0;
                    }
                }
                if (value == 'available') {
                    if (condition_val[index] == 'no') {
                        if (!productData[value]) return check = 0;
                    } else {
                        if (productData[value]) return check = 0;
                    }

                }
                if (value == 'tags') {
                    if (condition_name[index] == 'equal') {
                        if (jQuery.inArray(condition_val[index], productData.tags) == -1) return check = 0;
                    }
                    if (condition_name[index] == 'not_equal') {
                        if (jQuery.inArray(condition_val[index], productData.tags) !== -1) return check = 0;
                    }
                }
                if (value == 'collection') {
                    let collectionJson = JSON.parse(condition_val[index]);
                    if (condition_name[index] == 'equal') {
                        if (jQuery.inArray(Number(collectionJson.id), collectionData) == -1) return check = 0;
                    }
                    if (condition_name[index] == 'not_equal') {
                        if (jQuery.inArray(Number(collectionJson.id), collectionData) !== -1) return check = 0;
                    }
                }
                if (value == 'price') {
                    if (condition_name[index] == 'equal') {
                        if (productData[value] != Number(condition_val[index]) * 100) return check = 0;
                    }
                    if (condition_name[index] == 'not_equal') {
                        if (productData[value] == Number(condition_val[index]) * 100) return check = 0;
                    }
                    if (condition_name[index] == 'greater') {
                        if (productData[value] <= Number(condition_val[index]) * 100) return check = 0;
                    }
                    if (condition_name[index] == 'less') {
                        if (productData[value] >= Number(condition_val[index]) * 100) return check = 0;
                    }
                }
            });
            return check;
        }

        function checkConditions(conditionsRaw, productData, productCollection) {
            var mode = conditionsRaw.show_conditions;
            var condition_key = [];
            var condition_name = [];
            var condition_val = [];
            if (Array.isArray(conditionsRaw.condition_key)) {
                condition_key = conditionsRaw.condition_key;
                condition_name = conditionsRaw.condition_name;
                condition_val = conditionsRaw.condition_val;
            } else {
                condition_key.push(conditionsRaw.condition_key);
                condition_name.push(conditionsRaw.condition_name);
                condition_val.push(conditionsRaw.condition_val);
            }
            if (mode == 1)
                return checkConditionsAnd(condition_key, condition_name, condition_val, productData, productCollection);
            else
                return checkConditionsOr(condition_key, condition_name, condition_val, productData, productCollection);
            return 0;

        }

        function addButtonList_4(objectView, formID, ele_itemList, array_remove_price, array_remove_btn, array_ele_qty_remove, ele_frm_detail) {
            jQuery(".ify-quote-group").each(function() {
                var that = jQuery(this);
                var prdId = jQuery(this).attr('data-targetid');
                var productCurrent = '';
                if (typeof appConfig.product !== 'undefined')
                    productCurrent = appConfig.product.id;
                var prdCollections4 = getCollectionsForElement(that, prdId);
                const jsonEle = document.getElementById('ify_json_item_'+prdId);
                const dataJson = jsonEle !== undefined && jsonEle !== null ? JSON.parse(jsonEle.textContent) : null; 
                if (appConfig.productdata[prdId] && !that.hasClass('ify-has-modal')) {
                    if (checkConditions(objectView, appConfig.productdata[prdId], prdCollections4 || appConfig.collections[prdId]) == 1) {
                        if (prdId.toString() != productCurrent) {
                            that.removeClass('ify-hide').addClass('ify-has-modal storeify-button-grid');
                            if (typeof that.children('button').attr('data-id') == 'undefined' || that.children('button').attr('data-id') == '')
                                that.children('button').attr('data-id', formID).attr('data-target', '#storeify-light-modal-' + formID).attr('aria-controls','storeify-light-modal-' + formID).attr('aria-haspopup','dialog').attr('aria-expanded','false').before(login_see_btn);
                            else
                                that.children('button').before(login_see_btn);
                            if (config_reponse.remove_price == 1)
                                removeFromlistingpage(that, ele_itemList, array_remove_price);
                            if (config_reponse.remove_button == 1)
                                removeFromlistingpage(that, ele_itemList, array_remove_btn);
                        } else {
                            that.removeClass('ify-hide').addClass('ify-has-modal storeify-button-detail');
                            if (typeof that.children('button').attr('data-id') == 'undefined' || that.children('button').attr('data-id') == '')
                                that.children('button').attr('data-id', formID).attr('data-target', '#storeify-light-modal-' + formID).attr('aria-controls','storeify-light-modal-' + formID).attr('aria-haspopup','dialog').attr('aria-expanded','false').before(login_see_btn);
                            else
                                that.children('button').before(login_see_btn);
                            if (config_reponse.remove_price == 1)
                                removeFromdetailpage(array_remove_price, ele_frm_detail);
                            if (config_reponse.remove_button == 1) {
                                removeFromdetailpage(array_ele_qty_remove, ele_frm_detail);
                                removeFromdetailpage(array_remove_btn, ele_frm_detail);
                            }
                        }
                    }
                }else if(dataJson !== null && !that.hasClass('ify-has-modal')){
                    if (checkConditions(objectView, dataJson.productdata, prdCollections4 || dataJson.collections) == 1) {
                        if (prdId.toString() != productCurrent) {
                            that.removeClass('ify-hide').addClass('ify-has-modal storeify-button-grid');
                            if (typeof that.children('button').attr('data-id') == 'undefined' || that.children('button').attr('data-id') == '')
                                that.children('button').attr('data-id', formID).attr('data-target', '#storeify-light-modal-' + formID).attr('aria-controls','storeify-light-modal-' + formID).attr('aria-haspopup','dialog').attr('aria-expanded','false').before(login_see_btn);
                            else
                                that.children('button').before(login_see_btn);
                            if (config_reponse.remove_price == 1)
                                removeFromlistingpage(that, ele_itemList, array_remove_price);
                            if (config_reponse.remove_button == 1)
                                removeFromlistingpage(that, ele_itemList, array_remove_btn);
                        } else {
                            that.removeClass('ify-hide').addClass('ify-has-modal storeify-button-detail');
                            if (typeof that.children('button').attr('data-id') == 'undefined' || that.children('button').attr('data-id') == '')
                                that.children('button').attr('data-id', formID).attr('data-target', '#storeify-light-modal-' + formID).attr('aria-controls','storeify-light-modal-' + formID).attr('aria-haspopup','dialog').attr('aria-expanded','false').before(login_see_btn);
                            else
                                that.children('button').before(login_see_btn);
                            if (config_reponse.remove_price == 1)
                                removeFromdetailpage(array_remove_price, ele_frm_detail);
                            if (config_reponse.remove_button == 1) {
                                removeFromdetailpage(array_ele_qty_remove, ele_frm_detail);
                                removeFromdetailpage(array_remove_btn, ele_frm_detail);
                            }
                        }
                    }
                }
            });
            if (jQuery(".ify-quote-group").length == 0 && typeof appConfig.product !== 'undefined') {
                var sort_url = appConfig.product.handle;

                if (checkConditions(objectView, appConfig.product, appConfig.product.collection) == 1) {
                    var bntButton = '<div class="ify-quote-group ify-has-modal storeify-button-detail" data-targethandle="' + sort_url + '">' + login_see_btn + '<button type="button" class="storeify-quote-btn-trigger-popup btn button button--primary ify-button-code ify-button-code-mode-2" data-id="' + formID + '" data-target ="#storeify-light-modal-' + formID + '" aria-haspopup="dialog" aria-expanded="false" aria-controls="storeify-light-modal-' + formID + '" data-product="' + sort_url + '">' + storeify_lang.call_for_price + '</button></div>';
                    jQuery(ele_frm_detail).find('form[action=\"' + root_url + 'cart/add\"]').find('button[type="submit"]').eq(0).after(jQuery(bntButton));
                    if (config_reponse.remove_price == 1)
                        removeFromdetailpage(array_remove_price, ele_frm_detail);
                    if (config_reponse.remove_button == 1) {
                        removeFromdetailpage(array_ele_qty_remove, ele_frm_detail);
                        removeFromdetailpage(array_remove_btn, ele_frm_detail);
                    }
                }
            }
            if (jQuery(".ify-quote-group").length == 0 && typeof appConfig.product === 'undefined') {
                var ify_handles_done_4 = {};
                jQuery("a[href*='/products']").each(function() {
                    var url = jQuery(this).attr('href');
                    if (!url) return;
                    var h = url.substring(url.lastIndexOf('/') + 1).split("?")[0];
                    if (!h || ify_handles_done_4[h]) return;
                    ify_handles_done_4[h] = true;
                    var collIds = appConfig.collection ? [Number(appConfig.collection.id)] : [];
                    (function(sort_url, collectionIds) {
                        appConfig._ify_prd_cache = appConfig._ify_prd_cache || {};
                        if (appConfig._ify_prd_cache[sort_url]) {
                            var prd = appConfig._ify_prd_cache[sort_url];
                            var prdNorm = { id: prd.id, title: prd.title, handle: prd.handle, available: prd.available, vendor: prd.vendor, type: prd.product_type || prd.type || '', tags: prd.tags || [], price: prd.price };
                            if (checkConditions(objectView, prdNorm, collectionIds) == 1)
                                ifyInjectGridBtn(sort_url, formID, ele_itemList, array_remove_price, array_remove_btn);
                        } else {
                            jQuery.getJSON('/products/' + sort_url + '.js', function(prd) {
                                appConfig._ify_prd_cache[sort_url] = prd;
                                var prdNorm = { id: prd.id, title: prd.title, handle: prd.handle, available: prd.available, vendor: prd.vendor, type: prd.product_type || prd.type || '', tags: prd.tags || [], price: prd.price };
                                if (checkConditions(objectView, prdNorm, collectionIds) == 1)
                                    ifyInjectGridBtn(sort_url, formID, ele_itemList, array_remove_price, array_remove_btn);
                            });
                        }
                    })(h, collIds);
                });
            }
        }

        function ifyInjectGridBtn(sort_url, formID, ele_itemList, array_remove_price, array_remove_btn) {
            jQuery("a[href*='/products']").each(function() {
                var url = jQuery(this).attr('href');
                if (!url) return;
                var h = url.substring(url.lastIndexOf('/') + 1).split("?")[0];
                if (h !== sort_url) return;
                var that = jQuery(this);
                var parentItem = that.closest(ele_itemList.trim());
                if (parentItem.length > 0 && !parentItem.hasClass('ify-has-modal')) {
                    var bntButton = '<div class="ify-quote-group ify-has-modal storeify-button-grid" data-targethandle="' + sort_url + '">' + login_see_btn + '<button type="button" class="storeify-quote-btn-trigger-popup btn button button--primary ify-button-code ify-button-code-mode-4" data-id="' + formID + '" aria-haspopup="dialog" aria-expanded="false" aria-controls="storeify-light-modal-' + formID + '" data-target="#storeify-light-modal-' + formID + '" data-product="' + sort_url + '">' + storeify_lang.call_for_price + '</button></div>';
                    parentItem.addClass('ify-has-modal').append(bntButton);
                    if (config_reponse.remove_price == 1)
                        removeFromlistingpage(that, ele_itemList, array_remove_price);
                    if (config_reponse.remove_button == 1)
                        removeFromlistingpage(that, ele_itemList, array_remove_btn);
                }
            });
        }

        function getCollectionsForElement(el, prdId) {
            // Primary: appConfig.collections populated by Liquid inline scripts
            if (appConfig.collections && appConfig.collections[prdId]) return appConfig.collections[prdId];
            // Fallback: data-collections attribute (comma-separated IDs added via button_block.liquid)
            // Works when async-loaded HTML doesn't execute inline scripts
            var dataCol = el.attr('data-collections');
            if (dataCol && dataCol.trim() !== '') {
                return dataCol.split(',').map(function(id) { return id.trim(); });
            }
            return null;
        }
        function addButtonList_3(objectView, formID, ele_itemList, array_remove_price, array_remove_btn, array_ele_qty_remove, ele_frm_detail) {
            // currentClass = 'ify-in-grid';
            jQuery(".ify-quote-group").each(function() {
                var that = jQuery(this);
                var prdId = jQuery(this).attr('data-targetid');
                var checkCollec = 0;
                var productCurrent = '';
                if (typeof appConfig.product !== 'undefined')
                    productCurrent = appConfig.product.id;
                var prdCollections = getCollectionsForElement(that, prdId);
                if (prdCollections && !that.hasClass('ify-has-modal')) {
                    jQuery.each(prdCollections, function(i, v) {
                        if (jQuery.inArray(v.toString(), objectView) != -1)
                            checkCollec = 1;
                    });
                    if (checkCollec == 1) {
                        if (prdId.toString() != productCurrent) {
                            that.removeClass('ify-hide').addClass('ify-has-modal storeify-button-grid');
                            if (typeof that.children('button').attr('data-id') == 'undefined' || that.children('button').attr('data-id') == '')
                                that.children('button').attr('data-id', formID).attr('data-target', '#storeify-light-modal-' + formID).attr('aria-controls','storeify-light-modal-' + formID).attr('aria-haspopup','dialog').attr('aria-expanded','false').before(login_see_btn);
                            else
                                that.children('button').before(login_see_btn);
                            if (config_reponse.remove_price == 1)
                                removeFromlistingpage(that, ele_itemList, array_remove_price);
                            if (config_reponse.remove_button == 1)
                                removeFromlistingpage(that, ele_itemList, array_remove_btn);
                        } else {
                            that.removeClass('ify-hide').addClass('ify-has-modal storeify-button-detail');
                            if (typeof that.children('button').attr('data-id') == 'undefined' || that.children('button').attr('data-id') == '')
                                that.children('button').attr('data-id', formID).attr('data-target', '#storeify-light-modal-' + formID).attr('aria-controls','storeify-light-modal-' + formID).attr('aria-haspopup','dialog').attr('aria-expanded','false').before(login_see_btn);
                            else
                                that.children('button').before(login_see_btn);
                            if (config_reponse.remove_price == 1)
                                removeFromdetailpage(array_remove_price, ele_frm_detail);
                            if (config_reponse.remove_button == 1) {
                                removeFromdetailpage(array_ele_qty_remove, ele_frm_detail);
                                removeFromdetailpage(array_remove_btn, ele_frm_detail);
                            }
                        }
                    } else {
                        //jQuery(this).find('button').remove();
                    }
                }
            });
            if (jQuery(".ify-quote-group").length == 0 && typeof appConfig.product !== 'undefined') {
                var sort_url = appConfig.product.handle;
                var checkCollec = 0;
                jQuery.each(appConfig.product.collection, function(i, v) {
                    if (jQuery.inArray(v.toString(), objectView) != -1)
                        checkCollec = 1;
                });
                if (checkCollec == 1) {
                    var bntButton = '<div class="ify-quote-group ify-has-modal storeify-button-detail" data-targethandle="' + sort_url + '">' + login_see_btn + '<button type="button" class="storeify-quote-btn-trigger-popup btn button button--primary ify-button-code ify-button-code-mode-2" data-id="' + formID + '" data-target ="#storeify-light-modal-' + formID + '" aria-haspopup="dialog" aria-expanded="false" aria-controls="storeify-light-modal-' + formID + '" data-product="' + sort_url + '">' + storeify_lang.call_for_price + '</button></div>';
                    jQuery(ele_frm_detail).find('form[action=\"' + root_url + 'cart/add\"]').find('button[type="submit"]').eq(0).after(jQuery(bntButton));
                    if (config_reponse.remove_price == 1)
                        removeFromdetailpage(array_remove_price, ele_frm_detail);
                    if (config_reponse.remove_button == 1) {
                        removeFromdetailpage(array_ele_qty_remove, ele_frm_detail);
                        removeFromdetailpage(array_remove_btn, ele_frm_detail);
                    }
                }
            }
            if (jQuery(".ify-quote-group").length == 0 && typeof appConfig.product === 'undefined') {
                var currentColId = appConfig.collection ? appConfig.collection.id.toString() : '';
                if (currentColId && jQuery.inArray(currentColId, objectView) !== -1) {
                    jQuery("a[href*='/products']").each(function() {
                        var that = jQuery(this);
                        var url = that.attr('href');
                        if (!url) return;
                        var sort_url = url.substring(url.lastIndexOf('/') + 1).split("?")[0];
                        if (!sort_url) return;
                        var parentItem = that.closest(ele_itemList.trim());
                        if (parentItem.length > 0 && !parentItem.hasClass('ify-has-modal')) {
                            var bntButton = '<div class="ify-quote-group ify-has-modal storeify-button-grid" data-targethandle="' + sort_url + '">' + login_see_btn + '<button type="button" class="storeify-quote-btn-trigger-popup btn button button--primary ify-button-code ify-button-code-mode-3" data-id="' + formID + '" aria-haspopup="dialog" aria-expanded="false" aria-controls="storeify-light-modal-' + formID + '" data-target="#storeify-light-modal-' + formID + '" data-product="' + sort_url + '">' + storeify_lang.call_for_price + '</button></div>';
                            parentItem.addClass('ify-has-modal').append(bntButton);
                            if (config_reponse.remove_price == 1)
                                removeFromlistingpage(that, ele_itemList, array_remove_price);
                            if (config_reponse.remove_button == 1)
                                removeFromlistingpage(that, ele_itemList, array_remove_btn);
                        }
                    });
                }
            }

        }

        function addButtonList_2(objectView, formID, ele_itemList, array_remove_price, array_remove_btn, array_ele_qty_remove, ele_frm_detail,objectId=[]) {
            // currentClass = 'ify-in-grid';
            if (jQuery(".ify-quote-group").length > 0) {
                jQuery(".ify-quote-group").each(function() {
                    var that = jQuery(this);
                    var prdId = jQuery(this).attr('data-targetid');
                    var prdHandle = jQuery(this).attr('data-targethandle');
                    var checkHandle = 0;
                    var productCurrent = '';
                    if (typeof appConfig.product !== 'undefined')
                        productCurrent = appConfig.product.id;
                    if (!that.hasClass('ify-has-modal')) {
                        if (jQuery.inArray(prdHandle, objectView) !== -1 || jQuery.inArray(prdId.toString(), objectId) !== -1)
                            checkHandle = 1;

                        if (checkHandle == 1) {
                            if (prdId.toString() != productCurrent) {
                                that.removeClass('ify-hide').addClass('ify-has-modal storeify-button-grid');
                                if (typeof that.children('button').attr('data-id') == 'undefined' || that.children('button').attr('data-id') == '')
                                    that.children('button').attr('data-id', formID).attr('data-target', '#storeify-light-modal-' + formID).attr('aria-controls','storeify-light-modal-' + formID).attr('aria-haspopup','dialog').attr('aria-expanded','false').before(login_see_btn);
                                else
                                    that.children('button').before(login_see_btn);
                                if (config_reponse.remove_price == 1)
                                    removeFromlistingpage(that, ele_itemList, array_remove_price);
                                if (config_reponse.remove_button == 1)
                                    removeFromlistingpage(that, ele_itemList, array_remove_btn);
                            } else {
                                that.removeClass('ify-hide').addClass('ify-has-modal storeify-button-detail');
                                if (typeof that.children('button').attr('data-id') == 'undefined' || that.children('button').attr('data-id') == '')
                                    that.children('button').attr('data-id', formID).attr('data-target', '#storeify-light-modal-' + formID).attr('aria-controls','storeify-light-modal-' + formID).attr('aria-haspopup','dialog').attr('aria-expanded','false').before(login_see_btn);
                                else
                                    that.children('button').before(login_see_btn);
                                if (config_reponse.remove_price == 1)
                                    removeFromdetailpage(array_remove_price, ele_frm_detail);
                                if (config_reponse.remove_button == 1) {
                                    removeFromdetailpage(array_ele_qty_remove, ele_frm_detail);
                                    removeFromdetailpage(array_remove_btn, ele_frm_detail);
                                }
                            }
                        } else {
                            //jQuery(this).find('button').remove();
                        }
                    }
                });
            } else {
                jQuery("a[href*='/products']").each(function() {
                    that = $(this);
                    var getlistUrl = that.attr('href');

                    getlistUrlSub = getlistUrl.substring(getlistUrl.lastIndexOf('/') + 1);
                    sort_url = getlistUrlSub.split("?")[0];
                    if ($.inArray(sort_url, objectView) !== -1) {
                        var parentItem = that.closest(ele_itemList.trim());
                        var bntButton = '<div class="ify-quote-group ify-has-modal storeify-button-grid" data-targethandle="' + sort_url + '">' + login_see_btn + '<button type="button" class="storeify-quote-btn-trigger-popup btn button button--primary ify-button-code ify-button-code-mode-2" data-id="' + formID + '" aria-haspopup="dialog" aria-expanded="false" aria-controls="storeify-light-modal-' + formID + '" data-target ="#storeify-light-modal-' + formID + '" data-product="' + sort_url + '">' + storeify_lang.call_for_price + '</button></div>';
                        if (!parentItem.hasClass('ify-has-modal'))
                            parentItem.addClass('ify-has-modal').append(bntButton);
                        if (config_reponse.remove_price == 1)
                            removeFromlistingpage(that, ele_itemList, array_remove_price);
                        if (config_reponse.remove_button == 1)
                            removeFromlistingpage(that, ele_itemList, array_remove_btn)
                    }
                });
                if (appConfig.page.type == 'product') {
                    var sort_url = appConfig.product.handle;
                    var prdId =  appConfig.product.id;
                    if ($.inArray(sort_url, objectView) !== -1 || $.inArray(prdId.toString(), objectId) !== -1) {
                        if (jQuery('.ify-quote-group').length > 0) {
                            jQuery('.ify-quote-group').removeClass('ify-hide').addClass('ify-has-modal storeify-button-detail');
                            jQuery('.ify-quote-group').children('button').attr('data-id', formID).attr('data-target', '#storeify-light-modal-' + formID).attr('aria-controls','storeify-light-modal-' + formID).attr('aria-haspopup','dialog').attr('aria-expanded','false').before(login_see_btn);
                        } else {
                            var bntButton = '<div class="ify-quote-group ify-has-modal storeify-button-detail" data-targethandle="' + sort_url + '">' + login_see_btn + '<button type="button" class="storeify-quote-btn-trigger-popup btn button button--primary ify-button-code ify-button-code-mode-2" data-id="' + formID + '" aria-haspopup="dialog" aria-expanded="false" aria-controls="storeify-light-modal-' + formID + '" data-target ="#storeify-light-modal-' + formID + '" data-product="' + sort_url + '">' + storeify_lang.call_for_price + '</button></div>';
                            jQuery(ele_frm_detail).find('form[action=\"' + root_url + 'cart/add\"]').find('button[type="submit"]').eq(0).after(jQuery(bntButton));
                        }

                        if (config_reponse.remove_price == 1)
                            removeFromdetailpage(array_remove_price, ele_frm_detail);
                        if (config_reponse.remove_button == 1) {
                            removeFromdetailpage(array_ele_qty_remove, ele_frm_detail);
                            removeFromdetailpage(array_remove_btn, ele_frm_detail);
                        }
                    }
                }
            }
        }

        function addButtonList_1(objectView, formID, ele_itemList, array_remove_price, array_remove_btn, array_ele_qty_remove, ele_frm_detail) {
            // currentClass = 'ify-in-grid';
            if (jQuery(".ify-quote-group").length > 0) {
                jQuery(".ify-quote-group").each(function() {
                    var that = jQuery(this);
                    var prdId = jQuery(this).attr('data-targetid');
                    var prdHandle = jQuery(this).attr('data-targethandle');
                    var checkHandle = 0;
                    var productCurrent = '';
                    if (typeof appConfig.product !== 'undefined')
                        productCurrent = appConfig.product.id;
                    if (!that.hasClass('ify-has-modal')) {
                        if (prdId.toString() != productCurrent) {
                            that.removeClass('ify-hide').addClass('ify-has-modal storeify-button-grid');
                            if (typeof that.children('button').attr('data-id') == 'undefined' || that.children('button').attr('data-id') == '')
                                that.children('button').attr('data-id', formID).attr('data-target', '#storeify-light-modal-' + formID).attr('aria-controls','storeify-light-modal-' + formID).attr('aria-haspopup','dialog').attr('aria-expanded','false').before(login_see_btn);
                            else
                                that.children('button').before(login_see_btn);
                            if (config_reponse.remove_price == 1)
                                removeFromlistingpage(that, ele_itemList, array_remove_price);
                            if (config_reponse.remove_button == 1)
                                removeFromlistingpage(that, ele_itemList, array_remove_btn);
                        } else {
                            that.removeClass('ify-hide').addClass('ify-has-modal storeify-button-detail');
                            if (typeof that.children('button').attr('data-id') == 'undefined' || that.children('button').attr('data-id') == '')
                                that.children('button').attr('data-id', formID).attr('data-target', '#storeify-light-modal-' + formID).attr('aria-controls','storeify-light-modal-' + formID).attr('aria-haspopup','dialog').attr('aria-expanded','false').before(login_see_btn);
                            else
                                that.children('button').before(login_see_btn);
                            if (config_reponse.remove_price == 1)
                                removeFromdetailpage(array_remove_price, ele_frm_detail);
                            if (config_reponse.remove_button == 1) {
                                removeFromdetailpage(array_ele_qty_remove, ele_frm_detail);
                                removeFromdetailpage(array_remove_btn, ele_frm_detail);
                            }
                        }
                    }
                });
            } else {
                jQuery("a[href*='/products']").each(function() {
                    that = $(this);
                    var getlistUrl = that.attr('href');

                    getlistUrlSub = getlistUrl.substring(getlistUrl.lastIndexOf('/') + 1);
                    sort_url = getlistUrlSub.split("?")[0];

                    var parentItem = that.closest(ele_itemList.trim());
                    var bntButton = '<div class="ify-quote-group ify-has-modal storeify-button-grid" data-targethandle="' + sort_url + '">' + login_see_btn + '<button type="button" class="storeify-quote-btn-trigger-popup btn button button--primary ify-button-code ify-button-code-mode-1" data-id="' + formID + '" aria-haspopup="dialog" aria-expanded="false" aria-controls="storeify-light-modal-' + formID + '" data-target ="#storeify-light-modal-' + formID + '" data-product="' + sort_url + '">' + storeify_lang.call_for_price + '</button></div>';
                    if (!parentItem.hasClass('ify-has-modal'))
                        parentItem.addClass('ify-has-modal').append(bntButton);
                    if (config_reponse.remove_price == 1)
                        removeFromlistingpage(that, ele_itemList, array_remove_price);
                    if (config_reponse.remove_button == 1)
                        removeFromlistingpage(that, ele_itemList, array_remove_btn)

                });
                if (appConfig.page.type == 'product') {
                    var sort_url = appConfig.product.handle;

                    if (jQuery('.ify-quote-group').length > 0) {
                        jQuery('.ify-quote-group').removeClass('ify-hide').addClass('ify-has-modal storeify-button-detail');
                        jQuery('.ify-quote-group').children('button').attr('data-id', formID).attr('data-target', '#storeify-light-modal-' + formID).attr('aria-controls','storeify-light-modal-' + formID).attr('aria-haspopup','dialog').attr('aria-expanded','false').before(login_see_btn);
                    } else {
                        var bntButton = '<div class="ify-quote-group ify-has-modal storeify-button-detail" data-targethandle="' + sort_url + '">' + login_see_btn + '<button type="button" class="storeify-quote-btn-trigger-popup btn button button--primary ify-button-code ify-button-code-mode-1" data-id="' + formID + '" aria-haspopup="dialog" aria-expanded="false" aria-controls="storeify-light-modal-' + formID + '" data-target ="#storeify-light-modal-' + formID + '" data-product="' + sort_url + '">' + storeify_lang.call_for_price + '</button></div>';
                        jQuery(ele_frm_detail).find('form[action=\"' + root_url + 'cart/add\"]').find('button[type="submit"]').eq(0).after(jQuery(bntButton));
                    }

                    if (config_reponse.remove_price == 1)
                        removeFromdetailpage(array_remove_price, ele_frm_detail);
                    if (config_reponse.remove_button == 1) {
                        removeFromdetailpage(array_ele_qty_remove, ele_frm_detail);
                        removeFromdetailpage(array_remove_btn, ele_frm_detail);
                    }

                }
            }
        }

        function submitAjax(form) {
            var pageType = '';
            if (typeof meta.pageType == 'undefined') {
                if (window.location.pathname.indexOf('/cart')) {
                    pageType = 'cart';
                }
                if (window.location.pathname.indexOf('/acount')) {
                    pageType = 'acount';
                }
            } else {
                pageType = meta.pageType + '-' + meta.resourceId;
            }
            form.find('.submit_from').val(pageType);
            let dataFrm = form.serialize();
            
            jQuery.ajaxSetup({
                headers: {
                    'X-CSRF-TOKEN': form.find("input[name='_token']").val()
                }
            });
            jQuery.ajax({
                type: 'POST',
                url: form.attr('action'),
                data: dataFrm,
                async: true,
                cache: true,
                beforeSend: function() {
                    form.parent().addClass('storeify-frm-loading');

                },

                success: function(response) {
                    let mes = response.mes;
                    if (response.status == 0) {
                        form.next(".storeify-requestaquote-mes").addClass('storeify-mes-alert');
                    } else {
                        form.next(".storeify-requestaquote-mes").addClass('storeify-mes-success');
                        if (config_reponse.enable_print == 1) {
                            var htmlPrint = '<div class="ify-quote-group-print"><div class="ify_print_content" style="display:none;">' + response.html_print + '</div>';
                            var print_pdf = storeify_lang.print || 'Print PDF';
                            // htmlPrint += '<button type="button" class="button btn quote-ify-print">' + print_pdf + '</button></div>';
                            htmlPrint += '<a href="'+response.url_print+'" target="_blank" class="button btn quote-ify-print">' + print_pdf + '</button></div>';
                            // form.next(".storeify-requestaquote-mes").append(htmlPrint);
                            mes = mes + htmlPrint
                        }
                        if ((typeof appConfig.callbackTracking) === 'function') {
                            let callback = appConfig.callbackTracking;
                            callback(response.data);
                        }
                        
                        gtmTrackingQuote(response);
                        if (response.thankyoupage_url)
                            jQuery(location).attr('href', response.thankyoupage_url);
                    }
                    if(response.thankyoupage_url == '' || response.thankyoupage_url == null){
                        form.parent().removeClass('storeify-frm-loading');
                        form.css("visibility", "hidden");
                        form.next(".storeify-requestaquote-mes").removeClass('storeify-mes-alert');
                        form.next(".storeify-requestaquote-mes").removeClass('storeify-mes-success');
                        form.next(".storeify-requestaquote-mes").html(mes);
                        form.next(".storeify-requestaquote-mes").show();
                    }

                }

            });
        }

        function chekviewform(typeS, objectView,objectId = []) {
            var prdID = appConfig.product.id;
            var prdHandle = appConfig.product.handle;
            var collectionArr = appConfig.product.collection;
            var productData = appConfig.product;
            if (typeS == '1') {
                return 1;
            }
            if (typeS == '2') {
                if ($.inArray(prdHandle, objectView) !== -1 || $.inArray(prdID.toString(), objectId) !== -1) return 1;
            }
            if (typeS == '3') {
                var checkCollec = 0;
                jQuery.each(collectionArr, function(i, v) {
                    if (jQuery.inArray(v.toString(), objectView) != -1)
                        checkCollec = 1;
                });
                if (checkCollec == 1) return 1;
            }
            if (typeS == '4') {
                return checkConditions(objectView, productData, collectionArr);
            }
            return 0;
        }
        function getVariantId() {
          const params = new URLSearchParams(window.location.search);
          return params.get('variant') || '';
        }
        function jviewFormbuilder_detail(id, html, upload, max, storeify_filezie, ele_itemList, array_remove_price, array_remove_btn, array_ele_qty_remove, ele_frm_detail,shippingQuote={}) {
            jQuery(document).ready(function() {
                if (jQuery(".ify-quote-group").length > 0) {
                    // Guard against duplicate ".ify-quote-group" elements matching the same
                    // product (e.g. same product referenced in multiple page sections). Only
                    // the FIRST match may receive the form markup — otherwise multiple forms
                    // sharing the same id="storeify_form_action_<id>" get injected, but
                    // .validate()/submit-handler binding below only attaches to the first DOM
                    // match (jQuery's #id selector uses getElementById). Any duplicate copies
                    // would then have NO validator attached, so submitting through them bypasses
                    // validation entirely and falls back to a native form submit straight to
                    // the form's action URL.
                    var storeifyDetailFormBuilt = jQuery('#storeify_form_action_' + id).length > 0;
                    jQuery(".ify-quote-group").each(function() {
                        var that = jQuery(this);
                        var prdId = jQuery(this).attr('data-targetid');
                        var prdHandle = jQuery(this).attr('data-targethandle');
                        var checkHandle = 0;
                        var productCurrent = '';
                        if (typeof appConfig.product !== 'undefined')
                            productCurrent = appConfig.product.id;
                        if (!that.hasClass('ify-has-modal')) {
                            if (prdId.toString() == productCurrent || that.hasClass('ify-embed-code')) {
                                if (storeifyDetailFormBuilt) {
                                    return;
                                }
                                storeifyDetailFormBuilt = true;
                                that.removeClass('ify-hide').addClass('ify-has-modal storeify-button-detail');
                                that.html(html);
                                jQuery('.storeify_money_format').val(appConfig.money_format);
                                jQuery('.storeify_currency').val(window.ShopifyAnalytics.meta.currency);
                                jQuery('.storeify_country_code').val(window.Shopify.country);
                                jQuery('.storeify_localization').val(appConfig.locale);
                                if (typeof appConfig.customer !== 'undefined') {
                                    //console.log(appConfig.customer)
                                    jQuery('.storeify-form-action-quote input[name="storeifyInput_first_name"]').val(appConfig.customer.first_name);
                                    jQuery('.storeify-form-action-quote input[name="storeifyInput_last_name"]').val(appConfig.customer.last_name);
                                    jQuery('.storeify-form-action-quote input[name="storeifyInput_email"]').val(appConfig.customer.email);
                                    jQuery('.storeify-requestaquote input[name="customer"]').val(appConfig.customer.id);
                                    jQuery('.storeify-requestaquote input[name="storeify_default_address"]').val(JSON.stringify(appConfig.customer.default_address));
                                }
                                if (config_reponse.remove_price == 1)
                                    removeFromdetailpage(array_remove_price, ele_frm_detail);
                                if (config_reponse.remove_button == 1) {
                                    removeFromdetailpage(array_ele_qty_remove, ele_frm_detail);
                                    removeFromdetailpage(array_remove_btn, ele_frm_detail);
                                }
                            }
                        }
                    });
                } else {
                    jQuery(ele_frm_detail).find('form[action=\"' + root_url + 'cart/add\"]').last().after(jQuery(html));
                    jQuery('.storeify_money_format').val(appConfig.money_format);
                    jQuery('.storeify_currency').val(window.ShopifyAnalytics.meta.currency);
                    jQuery('.storeify_country_code').val(window.Shopify.country);
                    jQuery('.storeify_localization').val(appConfig.locale);
                    if (typeof appConfig.customer !== 'undefined') {
                        //console.log(appConfig.customer)
                        jQuery('.storeify-form-action-quote input[name="storeifyInput_first_name"]').val(appConfig.customer.first_name);
                        jQuery('.storeify-form-action-quote input[name="storeifyInput_last_name"]').val(appConfig.customer.last_name);
                        jQuery('.storeify-form-action-quote input[name="storeifyInput_email"]').val(appConfig.customer.email);
                        jQuery('.storeify-requestaquote input[name="customer"]').val(appConfig.customer.id);
                        jQuery('.storeify-requestaquote input[name="storeify_default_address"]').val(JSON.stringify(appConfig.customer.default_address));
                    }
                    if (config_reponse.remove_price == 1)
                        removeFromdetailpage(array_remove_price, ele_frm_detail);
                    if (config_reponse.remove_button == 1) {
                        removeFromdetailpage(array_ele_qty_remove, ele_frm_detail);
                        removeFromdetailpage(array_remove_btn, ele_frm_detail);
                    }
                }
                initIntlTelInputForStoreify('#storeify_form_action_' + id);
                // jQuery('body').append(html);
                var storeify_lang_cf = {
                    autoclose: true,
                    ignoreReadonly: true,
                    format: 'DD/MM/YYYY'
                };
                if (typeof appConfig.moment_lang !== 'undefined' && appConfig.moment_lang !== '') 
                    storeify_lang_cf = {
                        locale: appConfig.moment_lang,
                        autoclose: true,
                        ignoreReadonly: true,
                        format: 'DD/MM/YYYY'
                    };
                var class_col = 'storeify-col-1';
                var qty_element_html = '<input type="hidden" class="ify_qty_input" id="ify_qty_input" name="ify_qty" value="1">';
                if (show_qty_modal == 1) {
                    let textMax = ''
                    if(ify_maxQty != '') textMax = 'max="'+ify_maxQty+'"';
                    qty_element_html = '<div class="storeify-frm-group storeify-col-1 ify_qty_group"><label class="storeify-label-control storeify-label-type-input-text" for="ify_qty_input">' + storeify_lang.tbl_qty + '</label><div class="storeify-div-input">';
                    qty_element_html += '<input type="text" class="storeify-input-control storeify-input-text ify_qty_input" placeholder="' + storeify_lang.tbl_qty + '" name="ify_qty" id="ify_qty_input" min="'+ify_minQty+'" '+textMax+'  value="'+ify_minQty+'" required aria-required="true">';
                    qty_element_html += '</div></div>';
                }
                jQuery(".datetimepicker-input").each(function() {
                    storeify_lang_cf.format = jQuery(this).attr('data-format');
                    jQuery(this).datetimepicker(storeify_lang_cf);
                });
                var form_popup = jQuery('#storeify_form_action_' + id);

                var target = '#storeify-form-group-' + id;
                var product_json = appConfig.product.handle;
                var variant_id = '';
                var qty = ify_minQty;
                if (variant_element != '' && jQuery(ele_frm_detail).find(variant_element).length) {
                    variant_id = jQuery(ele_frm_detail).find(variant_element).val();
                } else {
                    if(ify_variant_url || jQuery(ele_frm_detail).find('form[action=\"' + root_url + 'cart/add\"]').find('[name="id"]').length == 0){
                        variant_id = getVariantId();
                    }else{
                        variant_id = jQuery(ele_frm_detail).find('form[action=\"' + root_url + 'cart/add\"]').find('[name="id"]').val();
                    }
                    
                }

                if (qty_element != '') {
                    qty = jQuery(ele_frm_detail).find(qty_element).val();
                } else {
                    qty = jQuery(ele_frm_detail).find('input[name="quantity"]').val();
                }

                let ify_upload_label = upload.upload_label;

                if(Object.keys(langOtherIfy).length !== 0 && typeof langOtherIfy[id][appConfig.locale] !== 'undefined'){
                    const langOtherIfy_1 = langOtherIfy[id][appConfig.locale];
                    if(typeof langOtherIfy_1['title'] !== 'undefined' && typeof langOtherIfy_1['title'] !== ''){
                        jQuery(`#storeify_form_action_${id} .storeify-title-frm`).html(langOtherIfy_1['title']);
                        jQuery(`#storeify_form_action_${id} .title-frm-hide`).val(langOtherIfy_1['title']);
                    }
                    if(typeof langOtherIfy_1['sub_title'] !== 'undefined' && typeof langOtherIfy_1['sub_title'] !== '')
                        jQuery(`#storeify_form_action_${id} .storeify-sub-title-frm`).html(langOtherIfy_1['sub_title']);
                    if(typeof langOtherIfy_1['submit_button'] !== 'undefined' && typeof langOtherIfy_1['submit_button'] !== '')
                        jQuery(`#storeify_form_action_${id} .storeify-submit-frm`).text(langOtherIfy_1['submit_button']);
                    if(typeof langOtherIfy_1['attachfile_text'] !== 'undefined' && typeof langOtherIfy_1['attachfile_text'] !== '')
                        ify_upload_label =  langOtherIfy_1['attachfile_text'];

                }

                jQuery.getJSON(root_url+'products/' + product_json + '.js', function(data) {
                    var handle_txt = data.handle
                    var html_content = '';
                    var price_element_html = '';
                    var priceDefault = 0;
                    var weightDefault = 0;
                    var sku = '';
                    var check_first = 0;
                    if (data.variants.length > 0) {
                        var hide_css = '';
                        if (data.variants.length == 1) hide_css = 'style="display:none;"';
                        var html_option = '<div class="storeify-frm-group ' + class_col + ' storeify-div-select storeify-div-input storeify-option-variants" ' + hide_css + '><select data-target="' + target + '" id="storeify_option_variants" name="variant_id" class="storeify-input-control storeify-select form-control-select">';
                        var html_img = '';
                        var src_img = '';
                        var html_title = '';
                        if (data.featured_image) src_img = data.featured_image;
                        jQuery.each(data.variants, function(k, v) {
                            if (v.featured_image) src_img = v.featured_image.src;
                            if (v.sku && v.sku != 'null') sku = v.sku;
                            if ((v.available == true && appConfig.hide_variants_outofstock == 1) || appConfig.hide_variants_outofstock == 0) {
                                if (check_first == 0) {
                                    check_first = 1;
                                    priceDefault = v.price;
                                    weightDefault = v.weight;
                                    html_title = '<h5 class="variant-title" style="display:none;">' + v.name + '</h5>' + '<input type="hidden" name="storeify_product_variant" class="storeify_product_variant"  value="' + v.id + '">' + '<input type="hidden" name="storeify_product_option" class="storeify_product_option" value="' + v.title + '"">';
                                    html_title += '<input type="hidden" name="storeify_product_sku" class="storeify_product_sku" value="' + sku + '"">';
                                    html_img = '<div class="ify-product-thumbnail" style="display:none;"><img class="storeify-thumbnail" src="' + src_img + '" /></div>';
                                    html_option += '<option selected="selected" value="' + v.id + '" data-pricedefault="' + v.price + '" data-weight="' + v.weight + '" data-sku="' + sku + '" data-img="' + src_img + '" data-name="' + v.name.replace(/"/g, '&quot;') + '">' + v.title + '</option>';
                                } else {
                                    html_option += '<option value="' + v.id + '" data-pricedefault="' + v.price + '" data-weight="' + v.weight + '" data-sku="' + sku + '" data-img="' + src_img + '" data-name="' + v.name.replace(/"/g, '&quot;') + '" >' + v.title + '</option>';
                                }
                            }


                        });
                        html_option += '</select><i class="storeify-select-arrow"></i></div>' + qty_element_html;
                        if (ify_show_input_price == 1) {
                            var priceText = 'Price: ' + formatMoney(priceDefault, appConfig.money_format);
                            price_element_html = '<div class="storeify-frm-group storeify-col-1 ify_price_group"><div class="storeify-div-input">';
                            price_element_html += '<input type="text" class="storeify-input-control storeify-input-text ify_price_input" placeholder="' + storeify_lang.your_price + '" name="ify_price" id="ify_price_input" ><em class="ify-price-default">' + priceText + '</em>';
                            price_element_html += '</div></div>';
                            html_option += price_element_html;
                        }
                        let utm_source = getUtmSource();
                        let utm_input = '<input type="hidden" name="storeify_product_utm_source" class="storeify_product_utm_source" value="' + utm_source + '">';
                        let htmlShiping = '';
                        if(shippingQuote){
                            let priceRaw = priceDefault/100;
                            htmlShiping = renderShippings(shippingQuote,qty*weightDefault,qty*priceRaw);

                            htmlShiping = '<div class="ify-shipping-group">' + htmlShiping + '</div>';
                        }
                        html_content = '<div class="ify-product-head">' + html_img + '</div><div class="ify-product-body">' + html_title + utm_input + htmlShiping + html_option + '</div>';

                    } else {
                        html_title = '<h5>' + (storeify_lang.add_title).replace('{{product}}', data.title) + '</h5>';
                    }
                    if (html_content != '') {
                        jQuery(target).find('.storeify-body-frm').prepend('<div class="storeify_product_group">' + html_content + '</div>');
                        jQuery('.ify-shippings-json').val(JSON.stringify(shippingQuote));
                        if (variant_id != '' && typeof variant_id !== "undefined" && variant_id != null && appConfig.hide_variants_outofstock == 0)
                            jQuery('#storeify_option_variants').val(variant_id).trigger('change');
                        if (qty)
                            jQuery('.ify_qty_input').val(qty);
                    }
                    if (check_first == 0) {
                        jQuery(target).find('.storeify-submit-btn').prop('disabled', true);
                        jQuery(target).find('.storeify-requestaquote-mes').html('Sold out').addClass('storeify-mes-alert').show();
                        jQuery(target).find('.storeify-form-action-quote').css("visibility", "hidden");
                    } else {
                        jQuery(target).find('.storeify-submit-btn').prop('disabled', false);
                        jQuery(target).find('.storeify-requestaquote-mes').html('').removeClass('storeify-mes-alert').hide();
                        jQuery(target).find('.storeify-form-action-quote').css("visibility", "visible");
                    }
                    jQuery(target).find('.storeify_product_id').val(data.id);
                    jQuery(target).find('.storeify_product_title').val(data.title);
                    jQuery(target).find('.storeify_product_href').val(product_json);
                    if (jQuery(target).find('.storeify-title-frm').length > 0)
                        jQuery(target).find('.storeify-title-frm').text(jQuery(target).find('.title-frm-hide').val().replace("{{product-title}}", data.title));
                    form_popup.parent().removeClass('storeify-frm-loading');
                })

                addCustomMethod(jQuery.validator);
                customValidation(form_popup, id);
                if (upload.upload == 1)
                    uploadFile(id, ify_upload_label, upload.upload_url, max, storeify_filezie);
            });
        }
        function removeCustom(array) {
            jQuery('body').find(array.trim()).remove();
        }

        function ipLookUp(key, value, html_before_0,shippingQuote = null) {
            var filter_country_value = JSON.parse(value.filter_country_value);
            if(filter_country_value.length <= 1){
                renderItem(key, value,html_before_0,shippingQuote);
                return true;
            }
            var url = "http://ipinfo.io/json";
            //put code to theme.liquid  header: storeifyRequestaquote.token_ipinfo = "your token";
            if (typeof appConfig.token_ipinfo !== 'undefined') {
                url = "http://ipinfo.io/json?token="+appConfig.token_ipinfo;
            }

            jQuery.ajax({
                //async: false,
                method: "GET",
                url: url,
            }).done(function(response) {
                let rateList = {};
                jQuery.each(shippingQuote, function(key, v) {
                    let value = JSON.parse(v);
                    if(value.rate_countries_check && value.rate_countries_check == 1 && value.countries){
                        if(typeof value.countries == 'string' && value.countries == response.country ){
                            rateList[key] = v;
                        }
                        if(typeof value.countries != 'string' && jQuery.inArray(response.country, value.countries) != -1){
                            rateList[key] = v;
                        }
                    }else{
                        rateList[key] = v;
                    }
                        
                });
                if (filter_country_value[0] == 1) {
                    filter_country_value.splice(0, 1);
                    if (jQuery.inArray(response.country, filter_country_value) != -1)
                    //if(filter_country_value[1] == response.country)
                        renderItem(key, value,html_before_0,rateList);
                } else {
                    filter_country_value.splice(0, 1);
                    if (jQuery.inArray(response.country, rateList) == -1)
                    // if(filter_country_value[1] != response.country)
                        renderItem(key, value,html_before_0,rateList);
                }
            });
        }
        function addStyleHide(key, value){
            var styles = '';
            var hidePrice = '';
            var hideButton = '';
            var showButton = '';
            const myArray = value.class_hide.split(",");
            var before = '';
            jQuery.each( myArray, function( i, val ) {
                before = ',';
                if(i == 0) before = '';
                if(config_reponse.remove_price == 1)
                    hidePrice += before+val+'.ify-has-modal .ify-item-price,'+val+' .ify-has-modal .ify-item-price';
                if(config_reponse.remove_button == 1)
                    hideButton += before+val+'.ify-has-modal .ify-item-atc,'+val+' .ify-has-modal .ify-item-atc';
                if(config_reponse.hide_btn_quote == 0)
                    showButton += before+val+'.ify-has-modal .storeify-button-grid,'+val+' .ify-has-modal .storeify-button-grid';
            });
            styles = '<style id="ify-styles-frm-'+key+'">';
            if(hidePrice != '' && hidePrice != ',')
                styles += hidePrice+'{display:none !important;}';
            if(hideButton != '' && hideButton != ',')
                styles += hideButton+'{display:none !important;}'
            if(showButton != '' && showButton != ',')
                styles += showButton+'{display:block !important;}'
            styles += '</style>';
            jQuery('head').append(styles);
        }
        function replaceLangs(fields,formHtml = '') {
            // A field property with no value is stored as the literal string "null"
            // (app-wide convention, not real null/undefined) — without this guard it
            // gets inserted into the page verbatim, showing "null" text to customers.
            function ifySafeLangVal(v) {
                return (v !== undefined && v !== null && v !== '' && v !== 'null') ? v : '';
            }
            jQuery.each(fields, function(id, val) {
                let type = val.type;
                let defaultLang = val.langs.default;
                let localeLang = typeof val['langs'][appConfig.locale] !== 'undefined' ? val['langs'][appConfig.locale] : defaultLang;
                // jQuery.each(localeLang, function(key, valLang) {
                    if(type === 'subscribe' || type === 'text'){
                        formHtml = formHtml.replace("{{content_text_"+id+"}}", ifySafeLangVal(localeLang.content_text));
                    }else if(type === 'department' || type === 'select' || type === 'checkbox' || type === 'radio'){
                        // formHtml = formHtml.replace("{{content_text_"+id+"}}", valLang.content_text);
                        formHtml = formHtml.replace("{{label_"+id+"}}", ifySafeLangVal(localeLang.label));
                        if(jQuery.isArray(localeLang.option_label)){
                            jQuery.each(localeLang.option_label, function(i, op) {
                                formHtml = formHtml.replace("{{op_"+i+"_"+id+"}}", ifySafeLangVal(op));
                            });
                        }else{
                             formHtml = formHtml.replace("{{op_0_"+id+"}}", ifySafeLangVal(localeLang.option_label));
                        }
                        formHtml = formHtml.replace("{{descriptions_"+id+"}}", ifySafeLangVal(localeLang.descriptions));
                        if(type === 'department' || type === 'select')
                            formHtml = formHtml.replace("{{placeholder_"+id+"}}", ifySafeLangVal(localeLang.placeholder));
                    }else{
                        formHtml = formHtml.replace("{{label_"+id+"}}", ifySafeLangVal(localeLang.label));
                        formHtml = formHtml.replace("{{placeholder_"+id+"}}", ifySafeLangVal(localeLang.placeholder));
                        formHtml = formHtml.replace("{{descriptions_"+id+"}}", ifySafeLangVal(localeLang.descriptions));
                    }
                // })
            });
            return formHtml;
        }
        function getValidateMesLangs(fields) {
            let validateMes = {};
            jQuery.each(fields, function(id, val) {
                let type = val.type;
                let defaultLang = val.langs.default;
                let localeLang = typeof val['langs'][appConfig.locale] !== 'undefined' ? val['langs'][appConfig.locale] : defaultLang;
                if(type !== 'subscribe' && type !== 'text'){
                    let tam = {}
                    if(val.required === 'on')
                        tam['required'] = typeof localeLang.required_mes !== 'undefined' ? localeLang.required_mes : '';
                    if (type === 'email')
                        tam['email'] = typeof localeLang.email_mes !== 'undefined' && localeLang.email_mes !== '' ? localeLang.email_mes : 'Please enter a valid email address.';
                    if (type === 'phone')
                        tam['validPhone'] = typeof localeLang.phone_mes !== 'undefined' && localeLang.phone_mes !== '' ? localeLang.phone_mes : 'Please enter a valid phone number.';
                    if(typeof val.choose_validation !== 'undefined'){
                        if(jQuery.isArray(val.choose_validation)){
                            jQuery.each(val.choose_validation, function(k,validate) {
                                tam[validate] = typeof localeLang['mes_validation'][k] !== 'undefined' ? localeLang['mes_validation'][k] : '';
                            });
                        }else{
                            const validate = val.choose_validation;
                            if(jQuery.isArray(localeLang['mes_validation']))
                                tam[validate] = typeof localeLang['mes_validation'][0] !== 'undefined' ? localeLang['mes_validation'][0] : '';
                            else
                                tam[validate] = localeLang['mes_validation'];
                        }

                    }
                    if(Object.keys(tam).length !== 0){
                        if(type === 'checkbox' || type === 'radio')
                            id = id + '[]';
                        validateMes[id] = tam;
                    }
                }
            });
            return validateMes;
        }
        function renderItem(key, value, html_before_0,shippingQuote = null) {
            var html_before = html_before_0 + '<div class="storeify-light-modal" id="storeify-light-modal-' + key + '" role="dialog"  aria-labelledby="modalTitle_' + key + '" aria-describedby="modalDesc_' + key + '" aria-hidden="false" aria-modal="true" tabindex="-1"><div class="storeify-light-modal-content storeify-animated storeifyfadeInDown">';
            if (value.type == 0 && typeof appConfig.product !== 'undefined') {
                var html_before = html_before_0 + '<div class="storeify-form-group" id="storeify-form-group-' + key + '" ><div class="storeify-light-frm-content">';
            }
            var html_after = '</div></div>';
            var form_inner = value.html;
            if (value.status == 1) {
                
                if (config_reponse.enable_captcha == 1 && config_reponse.gg_site_key !== '' && config_reponse.gg_secret_key !== '') {
                    html_after += '<script type="text/javascript">' + 'function getCaptcha(ele,id){' + ' grecaptcha.ready(function() {' + ' grecaptcha.execute(\'' + config_reponse.gg_site_key + '\', {action: \'storeify_action_send_\'+id}).then(function(token) {' + ' $(ele+\' input[name="token"]\').val(token);' + ' $(ele+\' input[name="action"]\').val(\'storeify_action_send_\'+id);'

                    + '});;' + ' });' + '}' + 'var onloadCallback = function() {' + ' getCaptcha(\'.storeify-requestaquote-captcha\',\'0\');' + '};' + '$(\'#storeify_form_action_' + key + '\').submit(function() {' + 'getCaptcha(\'.storeify-requestaquote-captcha\',\'0\');' + '});' + '</script>';
                }
                if(typeof value.field_data !== 'undefined' ){
                    form_inner = replaceLangs(value.field_data,form_inner);
                }
                addStyleHide(key, value);
                if (value.type == 0 && typeof appConfig.product !== 'undefined') {
                    var checkfrmView = 0;
                    checkfrmView = chekviewform(value.show, value.view,value.view_id); 
                    if (checkfrmView == 1)
                        jviewFormbuilder_detail(key, html_before + form_inner + html_after, value.upload, max_file, file_size, ele_itemList, array_remove_price, array_remove_btn, array_ele_qty_remove, ele_frm_detail,shippingQuote);

                } else {
                    jviewFormbuilder(key, html_before + form_inner + html_after, value.upload, max_file, file_size,shippingQuote);
                    if (value.show == '4')
                        addButtonList_4(value.view, key, ele_itemList, array_remove_price, array_remove_btn, array_ele_qty_remove, ele_frm_detail);
                    if (value.show == '3')
                        addButtonList_3(value.view, key, ele_itemList, array_remove_price, array_remove_btn, array_ele_qty_remove, ele_frm_detail);
                    if (value.show == '2')
                        addButtonList_2(value.view, key, ele_itemList, array_remove_price, array_remove_btn, array_ele_qty_remove, ele_frm_detail,value.view_id);
                    if (value.show == '1')
                        addButtonList_1(value.view, key, ele_itemList, array_remove_price, array_remove_btn, array_ele_qty_remove, ele_frm_detail);
                }
            }
        }
        function rebindQuoteButtons() {
            console.log('rebindQuoteButtons>>>>>>>>')
            jQuery.each(frmParams, function(key, value) {
                if (!value || value.status != 1) return true;
                if (jQuery('#storeify_form_action_' + key).length == 0) return true;

                if (value.show == '4')
                    addButtonList_4(value.view, key, ele_itemList, array_remove_price, array_remove_btn, array_ele_qty_remove, ele_frm_detail);
                if (value.show == '3')
                    addButtonList_3(value.view, key, ele_itemList, array_remove_price, array_remove_btn, array_ele_qty_remove, ele_frm_detail);
                if (value.show == '2')
                    addButtonList_2(value.view, key, ele_itemList, array_remove_price, array_remove_btn, array_ele_qty_remove, ele_frm_detail, value.view_id);
                if (value.show == '1')
                    addButtonList_1(value.view, key, ele_itemList, array_remove_price, array_remove_btn, array_ele_qty_remove, ele_frm_detail);
            });
            //applyRecommendationsPriceRemoval();
        }
        function applyRecommendationsPriceRemoval() {
            if (config_reponse.remove_price != 1) return;

            var priceSelector = (array_remove_price || '').trim();
            if (priceSelector === '') return;

            jQuery('.storeify-request-bnt, .ify-quote-group').each(function() {
                var cardScope = jQuery(this).closest('product-recommendations .slider__item, product-recommendations li, .product-recommendations .slider__item, .product-recommendations li, .grid__item, .card-wrapper, .card');
                if (cardScope.length > 0) {
                    cardScope.find(priceSelector).remove();
                }
            });
        }
        function ifyCloakPricesInNode(node) {
            if (config_reponse.remove_price != 1) return;
            var priceSelector = (array_remove_price || '').trim();
            if (!priceSelector || !node || node.nodeType !== 1) return;
            try {
                var $node = jQuery(node);
                $node.find(priceSelector).css('visibility', 'hidden');
                if ($node.is(priceSelector)) $node.css('visibility', 'hidden');
            } catch(e) {}
        }
        function ifyCloakSearchPricesInNode(node) {
            console.log('ifyCloakSearchPricesInNode>>',node)
            if (config_reponse.remove_price != 1) return;
            var searchPriceSelector = (config_reponse.ele_search_price || '').trim();
            if (!searchPriceSelector || !node || node.nodeType !== 1) return;
            try {
                jQuery(node).find(searchPriceSelector).css('visibility', 'hidden');
            } catch(e) {}
        }
        function bindRecommendationsObserver() {
            console.log('bindRecommendationsObserver....')
            if (typeof MutationObserver === 'undefined') return;

            var debounceTimer = null;
            var scheduleRebind = function() {
                if (debounceTimer) clearTimeout(debounceTimer);
                debounceTimer = setTimeout(function() {
                    rebindQuoteButtons();
                    //applyRecommendationsPriceRemoval();
                    // Restore visibility for prices that were cloaked but not removed
                    // (removeFromlistingpage already .remove()'d matching ones from DOM)
                    if (config_reponse.remove_price == 1) {
                        var priceSelector = (array_remove_price || '').trim();
                        if (priceSelector) {
                            try { jQuery(priceSelector).css('visibility', ''); } catch(e) {}
                        }
                    }
                }, 120);
            };

            var shouldRebind = function(node) {
                if (!node || node.nodeType !== 1) return false;
                if (node.matches && (node.matches('product-recommendations') || node.matches('.product-recommendations') || node.matches('a[href*="/products"]'))) return true;
                if (node.querySelector && (node.querySelector('product-recommendations') || node.querySelector('.product-recommendations') || node.querySelector('a[href*="/products"]'))) return true;
                if (ele_itemList && ele_itemList.trim() && node.querySelector) {
                    try { if (node.querySelector(ele_itemList.trim())) return true; } catch(e) {}
                }
                return false;
            };

            var observer = new MutationObserver(function(mutations) {
                var needRebind = false;
                for (var _i = 0; _i < mutations.length; _i++) {
                    var mutation = mutations[_i];
                    if (!mutation.addedNodes || mutation.addedNodes.length === 0) continue;
                    for (var _j = 0; _j < mutation.addedNodes.length; _j++) {
                        var node = mutation.addedNodes[_j];
                        if (shouldRebind(node)) {
                            ifyCloakPricesInNode(node);
                            needRebind = true;
                        }
                    }
                }
                if (needRebind) scheduleRebind();
            });

            observer.observe(document.body, {
                childList: true,
                subtree: true
            });

            jQuery(document).on('shopify:section:load shopify:section:reorder shopify:block:select', function() {
                scheduleRebind();
            });

            //applyRecommendationsPriceRemoval();
        }
        function applySearchPriceRemoval() {
            console.log('applySearchPriceRemoval 1')
            if (config_reponse.remove_price != 1) return;
            var searchPriceSelector = (config_reponse.ele_search_price || '').trim();
            if (searchPriceSelector === '') return;

            var searchContainers = jQuery('predictive-search, .predictive-search, search-modal, .search-modal, .search-bar__results, .search-results, .nav-search-results, .search-popdown, .search-widget');
            if (searchContainers.length === 0) return;

            var searchLinks = searchContainers.find('a[href*="/products"]');
            if (searchLinks.length === 0) return;

            var hideSearchPrice = function(link) {
                var card = jQuery(link).closest('li, .card-wrapper, .card, .grid__item, [class*="product"], [class*="item"], [class*="result"]');
                if (card.length === 0) card = jQuery(link).parent();
                card.find(searchPriceSelector).hide();
            };
            console.log('applySearchPriceRemoval 2')
            // Build handle map from frmParams rules
            var hideHandles = {};
            var hideAll = false;

            jQuery.each(frmParams, function(key, value) {
                if (!value || value.status != 1) return true;
                if (value.show == '1') {
                    hideAll = true;
                    return false;
                }
                if (value.show == '2') {
                    // value.view = array of handles for this rule
                    jQuery.each(value.view || [], function(i, h) {
                        if (h) hideHandles[h.toString()] = true;
                    });
                }
                // show 3 (collection) and show 4 (conditions): fall through to DOM below
            });

            if (hideAll) {
                searchLinks.each(function() { hideSearchPrice(this); });
                return;
            }

            // Supplement with handles already rendered on the page via quote cards (covers show 3 & 4)
            jQuery('.ify-quote-group.ify-has-modal[data-targethandle]').each(function() {
                var handle = jQuery(this).attr('data-targethandle');
                if (handle) hideHandles[handle.toString()] = true;
            });

            if (Object.keys(hideHandles).length === 0) return;

            searchLinks.each(function() {
                var href = jQuery(this).attr('href') || '';
                var handle = href.substring(href.lastIndexOf('/') + 1).split('?')[0];
                if (hideHandles[handle]) hideSearchPrice(this);
            });
        }
        function bindSearchObserver() {
            
            if (typeof MutationObserver === 'undefined') return;
            var searchPriceSelector = (config_reponse.ele_search_price || '').trim();
            console.log('typeof MutationObserver....',searchPriceSelector)
            // if (searchPriceSelector === '') return;
            if (config_reponse.remove_price != 1) return;

            // Apply immediately for any already-visible search results
            applySearchPriceRemoval();

            var searchDebounce = null;
            var scheduleSearchHide = function() {
                if (searchDebounce) clearTimeout(searchDebounce);
                searchDebounce = setTimeout(function() {
                    
                    applySearchPriceRemoval();
                    // Restore visibility for search prices that were cloaked but not hidden by applySearchPriceRemoval
                    var searchPriceSelector = (config_reponse.ele_search_price || '').trim();
                    console.log(config_reponse,'applySearchPriceRemoval....',searchPriceSelector)
                    if (searchPriceSelector && config_reponse.remove_price == 1) {
                        try {
                            jQuery('predictive-search, .predictive-search, search-modal, .search-modal, .search-bar__results, .search-results, .nav-search-results, .search-popdown, .search-widget')
                                .find(searchPriceSelector).each(function() {
                                    // Only restore if not hidden by .hide() (display:none)
                                    if (jQuery(this).css('display') !== 'none') {
                                        jQuery(this).css('visibility', '');
                                    }
                                });
                        } catch(e) {}
                    }
                }, 80);
            };

            var isSearchNode = function(node) {
                console.log('isSearchNode>>>>',node)
                if (!node || node.nodeType !== 1) return false;
                var searchSelectors = ['predictive-search', 'search-modal', '.predictive-search', '.search-modal', '.search-bar__results', '.search-results', '.nav-search-results', '.search-popdown', '.search-widget'];
                for (var i = 0; i < searchSelectors.length; i++) {
                    if (node.matches && node.matches(searchSelectors[i])) return true;
                    if (node.querySelector && node.querySelector(searchSelectors[i])) return true;
                    if (node.closest && node.closest(searchSelectors[i])) return true;
                }
                return false;
            };

            var observer = new MutationObserver(function(mutations) {
                console.log('MutationObserver>>>')
                var needHide = false;
                for (var _i = 0; _i < mutations.length; _i++) {
                    var mutation = mutations[_i];
                    if (mutation.type === 'attributes' && isSearchNode(mutation.target)) {
                        needHide = true;
                        continue;
                    }
                    if (!mutation.addedNodes || mutation.addedNodes.length === 0) continue;
                    for (var _j = 0; _j < mutation.addedNodes.length; _j++) {
                        var node = mutation.addedNodes[_j];
                        if (isSearchNode(node)) {
                            ifyCloakSearchPricesInNode(node);
                            needHide = true;
                        }
                    }
                }
                if (needHide) scheduleSearchHide();
            });

            observer.observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['class', 'open', 'aria-expanded', 'aria-hidden'] });
        }
        function checkCustomerTag(tags,customer,customer_tagCondition = 1){
            if(customer === void 0) return false;
            if(customer_tagCondition  == 1){
                if(tags !== '' && tags !== null && tags !== void 0){
                    let customerTagArr = tags.split(",")
                    let checkCustomer = 1;
                    jQuery.each(customerTagArr, function(key, value) {
                        if(jQuery.inArray(String(value),customer.tags) === -1){
                            checkCustomer = 0;
                            return false;
                        }
                    })
                    if(checkCustomer === 0) return false;
                }
                return true;
            }else{
                if(tags !== '' && tags !== null && tags !== void 0){
                    let customerTagArr = tags.split(",")
                    let checkCustomer = 1;
                    jQuery.each(customerTagArr, function(key, value) {
                        if(jQuery.inArray(String(value),customer.tags) !== -1){
                            checkCustomer = 0;
                            return false;
                        }
                    })
                    if(checkCustomer === 0) return false;
                }
                return true;
            }
            return false;
        }
        removeCustom(remove_ele_custom);
        jQuery(document).ready(function() {
            var html_before_0 = '';
            
            if (config_reponse.enable_captcha == 1 && config_reponse.gg_site_key !== '') {
                html_before_0 = '<script src="https://www.google.com/recaptcha/api.js?onload=onloadCallback&render=' + config_reponse.gg_site_key + '"></script>';
            }
            jQuery.each(frmParams, function(key, value) {
                if(value.filter_customer == 1 && (value.customer_tag !== '' && typeof value.customer_tag !== 'undefined')){
                    let customer_tagCondition = 1;
                    if(typeof value.customer_tag_condition != 'undefined' && value.customer_tag_condition != 'null' && value.customer_tag_condition != null)
                        customer_tagCondition = Number(value.customer_tag_condition);
                    if(!checkCustomerTag(value.customer_tag,appConfig.customer,customer_tagCondition)) return true;
                }
                if (value.filter_lang == 1 && value.filter_lang_value !== '' && typeof value.filter_lang_value !== 'undefined') {
                    
                    var filter_lang_value = JSON.parse(value.filter_lang_value);
                    if(filter_lang_value.length <= 1){

                    }else{
                        if (filter_lang_value[0] == 1) {
                            filter_lang_value.splice(0, 1);
                            if (jQuery.inArray(appConfig.locale, filter_lang_value) == -1) return true;
                        } else {
                            filter_lang_value.splice(0, 1);
                            if (jQuery.inArray(appConfig.locale, filter_lang_value) != -1) return true;
                        }
                    }
                }
                if (typeof value.field_data !== 'undefined')
                    validateMesLangIfy[key] = getValidateMesLangs(value.field_data);
                if (typeof value.lang_other !== 'undefined')
                    langOtherIfy[key] = value.lang_other;
                if (value.filter_country != 1 && (config_reponse.shiping_country == 0 || config_reponse.enable_shipping == 0) ) {
                    renderItem(key, value, html_before_0,shippingQuote);
                } else {
                    ipLookUp(key, value, html_before_0,shippingQuote);
                }

            }); //end for
            jQuery('#storeify-requestaquote-hidden').remove();
            bindSearchObserver();
            bindRecommendationsObserver();
            
            jQuery(document).on("click", ".storeify-quote-btn-trigger-popup", function(e) {
                e.preventDefault();
                var storeify_lang_cf = {
                    autoclose: true,
                    ignoreReadonly: true,
                    format: 'DD/MM/YYYY'
                };
                var class_col = 'storeify-col-1';
                var qty_element_html = '<input type="hidden" class="ify_qty_input" id="ify_qty_input" name="ify_qty" value="1">';
                if (show_qty_modal == 1) {
                    // class_col = 'storeify-col-2';
                    let textMax = ''
                    if(ify_maxQty != '') textMax = 'max="'+ify_maxQty+'"';
                    qty_element_html = '<div class="storeify-frm-group storeify-col-1 ify_qty_group"><label class="storeify-label-control storeify-label-type-input-text" for="ify_qty">' + storeify_lang.tbl_qty + '</label><div class="storeify-div-input">';
                    qty_element_html += '<input type="text" class="storeify-input-control storeify-input-text ify_qty_input" placeholder="' + storeify_lang.tbl_qty + '" name="ify_qty" id="ify_qty_input" min="'+ify_minQty+'" '+textMax+'  value="'+ify_minQty+'" required>';
                    qty_element_html += '</div></div>';
                }
                if (typeof appConfig.moment_lang !== 'undefined' && appConfig.moment_lang !== '') 
                    storeify_lang_cf = {
                        locale: appConfig.moment_lang,
                        autoclose: true,
                        ignoreReadonly: true,
                        format: 'DD/MM/YYYY'
                    };
                //if(storeify_lang !== '') storeify_lang_cf = {locale:storeify_lang,autoclose:true,ignoreReadonly:true, format: 'DD/MM/YYYY'};
                jQuery(".datetimepicker-input").each(function() {
                    storeify_lang_cf.format = jQuery(this).attr('data-format');
                    jQuery(this).datetimepicker(storeify_lang_cf);
                });
                let id = jQuery(this).attr('data-id');
                var form_popup = jQuery('#storeify_form_action_' + jQuery(this).attr('data-id'));
                // initIntlTelInputForStoreify('#storeify_form_action_' + id);
                jQuery(form_popup).css("visibility", "visible");
                jQuery(form_popup).next(".storeify-requestaquote-mes").html('');
                jQuery(form_popup).next(".storeify-requestaquote-mes").hide();
                jQuery(form_popup).find('.storeify-input-control').each(function() {
                    if (jQuery(this).hasClass('storeify-select') && jQuery(this).attr('data-default') == '') {
                        jQuery(this).find('option:eq(0)').prop('selected', true);
                    } else {
                        jQuery(this).val(jQuery(this).attr('data-default'));
                    }

                });
                jQuery(form_popup).find('.bg-success').html('');
                jQuery(form_popup).find('.file-error-message').html('');
                let idForm = jQuery(this).attr('data-id');
                addCustomMethod(jQuery.validator);
                customValidation(form_popup, idForm);

                var target = jQuery(this).attr('data-target');
                var product_json = jQuery(this).attr('data-product');
                jQuery(target).find('.storeify_product_group').remove();
                form_popup.parent().addClass('storeify-frm-loading');
                var variant_id = '';
                var qty = ify_minQty;
                if (jQuery(this).parent().hasClass('storeify-button-detail')) {

                    if (variant_element != '' && jQuery(ele_frm_detail).find(variant_element).length) {
                        variant_id = jQuery(ele_frm_detail).find(variant_element).val();
                    } else {
                        if(ify_variant_url || jQuery(ele_frm_detail).find('form[action=\"' + root_url + 'cart/add\"]').find('[name="id"]').length == 0){
                            variant_id = getVariantId();
                        }else{
                            variant_id = jQuery(ele_frm_detail).find('form[action=\"' + root_url + 'cart/add\"]').find('[name="id"]').val();
                        }
                    }
                    
                    if (qty_element != '') {
                        qty = jQuery(ele_frm_detail).find(qty_element).val();
                    } else {
                        qty = jQuery(ele_frm_detail).find('input[name="quantity"]').val();
                    }
                }
                jQuery.getJSON(root_url+'products/' + product_json + '.js', function(data) {
                    var handle_txt = data.handle
                    var html_content = '';
                    var weightDefault = 0;
                    var priceDefault = 0;
                    var sku = '';
                    var check_first = 0;
                    if (data.variants.length > 0) {
                        var hide_css = '';
                        if (data.variants.length == 1) hide_css = 'style="display:none;"';
                        var html_option = '<div class="storeify-frm-group ' + class_col + ' storeify-div-select storeify-div-input storeify-option-variants" ' + hide_css + '><select data-target="' + target + '" id="storeify_option_variants" name="variant_id" class="storeify-input-control storeify-select form-control-select">';
                        var html_img = '';
                        var src_img = '';
                        var html_title = '';
                        if (data.featured_image) src_img = data.featured_image;
                        jQuery.each(data.variants, function(k, v) {
                            if (v.featured_image) src_img = v.featured_image.src;
                            if (v.sku && v.sku != 'null') sku = v.sku;
                            if ((v.available == true && appConfig.hide_variants_outofstock == 1) || appConfig.hide_variants_outofstock == 0) {
                                if (check_first == 0) {
                                    check_first = 1;
                                    priceDefault = v.price;
                                    html_title = '<h5 class="variant-title">' + data.title + '</h5>' + '<input type="hidden" name="storeify_product_variant" class="storeify_product_variant"  value="' + v.id + '">' + '<input type="hidden" name="storeify_product_option" class="storeify_product_option" value="' + v.title + '"">';
                                    html_title += '<input type="hidden" name="storeify_product_sku" class="storeify_product_sku" value="' + sku + '"">';
                                    html_img = '<div class="ify-product-thumbnail"><img class="storeify-thumbnail" src="' + src_img + '" /></div>';
                                    html_option += '<option selected="selected" value="' + v.id + '" data-pricedefault="' + v.price + '" data-weight="' + v.weight + '" data-sku="' + sku + '" data-img="' + src_img + '" data-name="' + v.name.replace(/"/g, '&quot;') + '">' + v.title + '</option>';
                                } else {
                                    html_option += '<option value="' + v.id + '" data-pricedefault="' + v.price + '" data-weight="' + v.weight + '" data-sku="' + sku + '" data-img="' + src_img + '" data-name="' + v.name.replace(/"/g, '&quot;') + '">' + v.title + '</option>';
                                }
                            }

                        });
                        html_option += '</select><i class="storeify-select-arrow"></i></div>' + qty_element_html;
                        if (ify_show_input_price == 1) {
                            var priceText = storeify_lang.old_price + ': ' + formatMoney(priceDefault, appConfig.money_format);
                            price_element_html = '<div class="storeify-frm-group storeify-col-1 ify_price_group"><div class="storeify-div-input">';
                            price_element_html += '<input type="text" class="storeify-input-control storeify-input-text ify_price_input" placeholder="' + storeify_lang.your_price + '" name="ify_price" id="ify_price_input" ><em class="ify-price-default">' + priceText + '</em>';
                            price_element_html += '</div></div>';
                            html_option += price_element_html;
                        }
                        let utm_source = getUtmSource();
                        let utm_input = '<input type="hidden" name="storeify_product_utm_source" class="storeify_product_utm_source" value="' + utm_source + '">';
                        let htmlShiping = '';
                        if(shippingQuote){
                            let priceRaw = priceDefault/100;
                            htmlShiping = renderShippings(shippingQuote,qty*weightDefault,qty*priceRaw);

                            htmlShiping = '<div class="ify-shipping-group">' + htmlShiping + '</div>';
                        }
                        html_content = '<div class="ify-product-head">' + html_img + '</div><div class="ify-product-body">' + html_title + htmlShiping + utm_input + html_option + '</div>';

                    } else {
                        html_title = '<h5>' + (storeify_lang.add_title).replace('{{product}}', data.title) + '</h5>';
                    }
                    if (html_content != '') {
                        jQuery(target).find('.storeify-body-frm').prepend('<div class="storeify_product_group">' + html_content + '</div>');
                        if (typeof appConfig.customer !== 'undefined') {
                            let customerInfo = appConfig.customer;
                            jQuery('.storeify-requestaquote input[name="storeifyInput_first_name"]').val(customerInfo.first_name);
                            jQuery('.storeify-requestaquote input[name="storeifyInput_last_name"]').val(customerInfo.last_name);
                            jQuery('.storeify-requestaquote input[name="storeifyInput_email"]').val(customerInfo.email);
                        }
                        
                        if (variant_id != '' && typeof variant_id !== "undefined" && variant_id != null && appConfig.hide_variants_outofstock == 0){
                            jQuery('#storeify_option_variants').val(variant_id).trigger('change');
                        }
                        if (qty)
                            jQuery('.ify_qty_input').val(qty);
                    }
                    if (check_first == 0) {
                        jQuery(target).find('.storeify-submit-btn').prop('disabled', true);
                        jQuery(target).find('.storeify-requestaquote-mes').html('Sold out').addClass('storeify-mes-alert').show();
                        jQuery(target).find('.storeify-form-action-quote').css("visibility", "hidden");
                    } else {
                        jQuery(target).find('.storeify-submit-btn').prop('disabled', false);
                        jQuery(target).find('.storeify-requestaquote-mes').html('').removeClass('storeify-mes-alert').hide();
                        jQuery(target).find('.storeify-form-action-quote').css("visibility", "visible");
                    }
                    jQuery(target).find('.storeify_product_id').val(data.id);
                    jQuery(target).find('.storeify_product_title').val(data.title);
                    jQuery(target).find('.storeify_product_href').val(product_json);
                    if (jQuery(target).find('.storeify-title-frm').length > 0)
                        jQuery(target).find('.storeify-title-frm').text(jQuery(target).find('.title-frm-hide').val().replace("{{product-title}}", data.title));
                    form_popup.parent().removeClass('storeify-frm-loading');
                })

                jQuery(this).attr('aria-expanded','true')
                jQuery(target).addClass('target').focus();
            });
            function changeShippings(option){
                if (jQuery('.ify-shipping-group').length && jQuery('.ify-shippings-json').length) {
                    let priceRaw = Number(option.attr('data-pricedefault'))/100;
                    let weightRaw = Number(option.attr('data-weight'));
                    let shippingsRaw = JSON.parse(jQuery('.ify-shippings-json').val());
                    let qtyRaw = 1;
                    if(jQuery('#ify_price_input').length && jQuery('#ify_price_input').val() != ''){
                        priceRaw = Number(jQuery('#ify_price_input').val());
                    }
                    if(jQuery('#ify_qty_input').length && jQuery('#ify_qty_input').val() != ''){
                        qtyRaw = Number(jQuery('#ify_qty_input').val());
                    }
                    let shippingsHtml = renderShippings(shippingsRaw,weightRaw*qtyRaw,priceRaw*qtyRaw);
                    jQuery('.ify-shipping-group').html(shippingsHtml);
                }
            }
            jQuery(document).on("change", "#storeify_option_variants", function(e) {
                var result = [];
                var title = jQuery(this).parent().parent().find('h5');
                var img = jQuery(this).parent().parent().parent().find('.storeify-thumbnail');
                var option = jQuery(this).find(":selected");
                var target = jQuery(this).attr('data-target')
                img.attr('src', option.attr('data-img'));
                //title.html(option.data('name'));

                jQuery(target).find('.storeify_product_variant').val(option.val());
                jQuery(target).find('.storeify_product_option').val(option.text());
                jQuery(target).find('.storeify_product_option').val(option.attr('data-sku'));
                if (jQuery('.ify-price-default').length) {
                    jQuery('.ify-price-default').text(storeify_lang.old_price + ': ' + formatMoney(option.attr('data-pricedefault'), appConfig.money_format));
                }
                changeShippings(option);
            });
            jQuery(document).on("change", "#ify_qty_input,#ify_price_input", function(e) {
                var option = jQuery('#storeify_option_variants').find(":selected");
                changeShippings(option);
            })
            jQuery(document).on("click", ".storeify-requestaquote-button", function(e) {
                e.preventDefault();
                var target = jQuery(this).attr('data-target');

                jQuery(target).addClass('target');
            });
            jQuery(document).on("click", ".storeify-frm-close", function(e) {
                e.preventDefault();
                var target = jQuery(this).parent().parent().parent();
                var target2 = jQuery(this).parent().parent();
                jQuery(target).removeClass('target');
                jQuery(target2).removeClass('target');
                jQuery('.storeify-quote-btn-trigger-popup').attr('aria-expanded','false')
            });
            // jQuery(document).on('click', '.quote-ify-print', function(e) {
            //     e.preventDefault();
            //     var dt = new Date().getTime();
            //     var contents = jQuery(".ify_print_content").html();
            //     var currentTitle = document.title;
            //     var style = '<style>';
            //     style += 'body{text-align:left;}';
            //     style += '.confirm-success{display:none}';
            //     style += '.confirm-product{display:block;width:100%;text-align: center;padding-bottom: 15px;}';
            //     style += '.prd-thumb{position: relative;display: inline-block;overflow: hidden;width: 120px;background: #fff;border: 0.1rem solid #e1e3e5;border-radius: 10px}';
            //     style += '.prd-thumb img{position: absolute;top: 0;right: 0;bottom: 0;left: 0;margin: auto;max-width: 100%;max-height: 100%;}';
            //     style += '.prd-thumb:after {content: "";display: block;padding-bottom: 100%;}';
            //     style += '.prd-title{font-size: 15px;font-weight: 600;padding:15px 0 20px 0}';
            //     // style += '.confirm-booking,.confirm-total{flex-direction: column;align-items: flex-start;display: flex;justify-content: space-between;font-size: 14px;width:500px;margin:0 auto;}';
            //     // style += '.confirm-booking > div,.confirm-total > div{width: 100%;margin-bottom: 5px;padding-bottom: 5px;display: flex;justify-content: space-between;}';
            //     // style += '.confirm-booking label,.confirm-total label{display: inline-block;margin-right: 2px;font-weight: 600;}';
            //     style += '</style>';
            //     var html = '<!DOCTYPE HTML>' +
            //     '<html>' +
            //     '<head>' +
            //     '<meta http-equiv="x-ua-compatible" content="IE=Edge"/><title>Quote Form</title>' +
            //     '<link rel="stylesheet" type="text/css" href="appRes/css/print.css?_dc=' + dt + '" media="all" />' + style +
            //     '</head>' +
            //     '<body>' +
            //     '<div class="print">' + contents + '</div>';

            //     html += '</body>';
            //     html += '</html>';
            //     document.title = 'Quote #' + dt;
            //     var iframe = this._printIframe;
            //     if (!this._printIframe) {
            //         iframe = this._printIframe = document.createElement('iframe');
            //         document.body.appendChild(iframe);

            //         iframe.style.display = 'none';
            //         iframe.onload = function () {
            //             setTimeout(function () {
            //                 iframe.focus();
            //                 iframe.contentWindow.print();
            //             }, 1);
            //         };
            //     }
            //     iframe.src = "about:blank";
            //     var doc = iframe.contentWindow.document;
            //     var windowUrl = window.location;    // iframe.contentWindow.location;
            //     var uniqueName = new Date();
            //     var windowName = 'Print' + uniqueName.getTime();

            //     this.testwindow = doc.open(windowUrl, windowName);

            //     doc.write(html);
            //     doc.close();
            //     setTimeout(function() {
            //         document.title = currentTitle;
            //     }, 500);

            // });//endprint
        });
        if (appConfig.page && appConfig.page.path == root_url + 'apps/request-a-quote/history' && typeof appConfig.customer !== 'undefined') {
            function historyLoad() {
                jQuery.ajax({
                    url: '/apps/request-a-quote/history/list',
                    type: 'GET',
                    dataType: 'json',
                    data: {
                        email: $('#ify_email').val(),
                        page: $('#ify_page').val(),
                        locale:appConfig.locale,
                    }
                }).done(function(data) {
                    jQuery('.btn-ify-more-history').prop('disabled', false);
                    if (data.status == 1) {
                        let page = $('#ify_page').val();
                        jQuery('table.ify-quote-histoty tbody').append(data.html);
                        jQuery('#ify_page').val(Number(page) + 1);
                        if (data.count < 10) {
                            $('.ify-quote-histoty tfoot').hide();
                        }
                    } else {
                        jQuery('table.ify-quote-histoty tbody').append(data.mes);
                    }

                });
            }
            historyLoad();
            jQuery(document).on("click", ".btn-ify-more-history", function(e) {
                e.preventDefault();
                jQuery(this).prop('disabled', true);
                historyLoad();
            });
            jQuery(document).on("click", ".ify-view-item", function(e) {
                e.preventDefault();
                var id = jQuery(this).attr('data-id');
                jQuery.ajax({
                    url: '/apps/request-a-quote/history/view',
                    type: 'GET',
                    dataType: 'json',
                    data: {
                        id: id,
                        locale:appConfig.locale
                    }
                }).done(function(data) {
                    if (data.status == 1)
                        $('#ify_view_item_history .view-item-history').html(data.html);
                    else
                        $('#ify_view_item_history .view-item-history').html(data.mes);
                    $('#ify_view_item_history').addClass('target');
                });
            });
        }


        // Hàm kiểm tra GTM đã tồn tại trong document
        function isGTMAlreadyExists(ify_idGtm = null) {
          // Kiểm tra script GTM chung
          const generalGTMScript = document.querySelector(`script[src*="googletagmanager.com/gtm.js"]`);
          
          // Kiểm tra script GTM với ID cụ thể (nếu có)
          const specificGTMScript = ify_idGtm ? 
            document.querySelector(`script[src*="gtm.js?id=${ify_idGtm}"]`) : null;
          
          // Kiểm tra noscript iframe
          const gtmNoScript = document.querySelector(`noscript iframe[src*="googletagmanager.com/ns.html"]`);
          
          // Kiểm tra dataLayer và gtag function
          const hasDataLayer = window.dataLayer && Array.isArray(window.dataLayer);
          const hasGtag = typeof window.gtag === 'function';
          
          return {
            hasGeneralScript: !!generalGTMScript,
            hasSpecificScript: !!specificGTMScript,
            hasNoScript: !!gtmNoScript,
            hasDataLayer: hasDataLayer,
            hasGtag: hasGtag,
            isAlreadyInstalled: !!(generalGTMScript || specificGTMScript || (hasDataLayer && hasGtag))
          };
        }
        // Hàm thêm Google Tag Manager vào header Shopify
        function addGTMToShopify(ify_idGtm) {
          // Kiểm tra GTM ID có hợp lệ không
          if (!ify_idGtm || !ify_idGtm.startsWith('GTM-')) {
            console.error('GTM ID không hợp lệ. Vui lòng nhập GTM ID đúng định dạng (GTM-XXXXXXX)');
            return false;
          }

          // Kiểm tra GTM đã tồn tại chưa
          const gtmStatus = isGTMAlreadyExists(ify_idGtm);
          
          if (gtmStatus.isAlreadyInstalled) {
            console.warn('Google Tag Manager đã được cài đặt:', {
              'Script chung': gtmStatus.hasGeneralScript,
              'Script cụ thể': gtmStatus.hasSpecificScript,
              'NoScript': gtmStatus.hasNoScript,
              'DataLayer': gtmStatus.hasDataLayer,
              'Gtag function': gtmStatus.hasGtag
            });
            return false;
          }

          try {
            // Thêm GTM script vào head
            const gtmScript = document.createElement('script');
            gtmScript.async = true;
            gtmScript.src = `https://www.googletagmanager.com/gtm.js?id=${ify_idGtm}`;
            
            // Thêm dataLayer và gtm configuration
            const configScript = document.createElement('script');
            configScript.innerHTML = `
              window.dataLayer = window.dataLayer || [];
              function gtag(){dataLayer.push(arguments);}
              gtag('js', new Date());
              gtag('config', '${ify_idGtm}');
            `;

            // Thêm vào head
            const head = document.head || document.getElementsByTagName('head')[0];
            head.insertBefore(configScript, head.firstChild);
            head.insertBefore(gtmScript, configScript.nextSibling);

            // Thêm noscript fallback vào body
            const noscript = document.createElement('noscript');
            noscript.innerHTML = `<iframe src="https://www.googletagmanager.com/ns.html?id=${ify_idGtm}" height="0" width="0" style="display:none;visibility:hidden"></iframe>`;
            
            // Thêm noscript vào đầu body
            const body = document.body || document.getElementsByTagName('body')[0];
            if (body) {
              body.insertBefore(noscript, body.firstChild);
            }

            // console.log(`Google Tag Manager (${ify_idGtm}) đã được thêm thành công!`);
            return true;

          } catch (error) {
            console.error('Lỗi khi thêm Google Tag Manager:', error);
            return false;
          }
        }
        // Hàm thêm GTM với event tracking cơ bản cho Shopify
        function addGTMWithShopifyEvents(ify_idGtm) {
          // Kiểm tra GTM đã tồn tại chưa trước khi thêm
          const gtmStatus = isGTMAlreadyExists(ify_idGtm);
          
          if (gtmStatus.isAlreadyInstalled) {
            console.warn(`GTM đã được cài đặt. Chỉ thêm Shopify event tracking...`);
            // addShopifyEventTracking();
            return true;
          }

          // Thêm GTM nếu chưa tồn tại
          if (!addGTMToShopify(ify_idGtm)) {
            return false;
          }

          // Thêm Shopify event tracking
          // addShopifyEventTracking();
          
          // console.log('GTM và Shopify event tracking đã được thêm thành công!');
          return true;
        }
        // Hàm riêng để thêm Shopify event tracking
        function addShopifyEventTracking() {
            // Kiểm tra xem event tracking đã được thêm chưa
            if (window.shopifyGTMEventsAdded) {
                // console.warn('Shopify GTM event tracking đã được thêm trước đó');
                return;
            }

            const shopifyEventsScript = document.createElement('script');
            shopifyEventsScript.innerHTML = `
            // Đánh dấu đã thêm event tracking
            window.shopifyGTMEventsAdded = true;
            
            // Track page views
            if (typeof gtag === 'function') {
              gtag('event', 'page_view', {
                page_title: document.title,
                page_location: window.location.href,
                page_path: window.location.pathname
              });
            }

            // Track scroll events
            let scrollTracked = false;
            window.addEventListener('scroll', function() {
              if (!scrollTracked && window.scrollY > (document.body.scrollHeight * 0.5)) {
                if (typeof gtag === 'function') {
                  gtag('event', 'scroll', {
                    event_category: 'engagement',
                    event_label: '50% page scroll'
                  });
                }
                scrollTracked = true;
              }
            });

            // Track clicks on external links
            document.addEventListener('click', function(e) {
              const link = e.target.closest('a');
              if (link && link.hostname !== window.location.hostname) {
                if (typeof gtag === 'function') {
                  gtag('event', 'click', {
                    event_category: 'outbound',
                    event_label: link.href,
                    transport_type: 'beacon'
                  });
                }
              }
            });

            // Shopify specific events (nếu có Shopify object)
            if (typeof Shopify !== 'undefined') {
              // Track cart events nếu có thông tin cart
              if (Shopify.checkout && typeof gtag === 'function') {
                gtag('event', 'begin_checkout', {
                  currency: Shopify.currency.active,
                  value: Shopify.checkout.total_price / 100
                });
              }
            }
          `;

            const head = document.head || document.getElementsByTagName('head')[0];
            head.appendChild(shopifyEventsScript);

            // console.log('Shopify event tracking đã được thêm!');
        }
        function gtmTrackingQuote(argument) {
            const hasDataLayer = window.dataLayer && Array.isArray(window.dataLayer);
            if(!hasDataLayer)
                return;
            window.dataLayer = window.dataLayer || [];
            // if (typeof gtag === 'function') {
            //     gtag('event', 'request_quote', {
            //       quoteId: Number(argument.id),
            //       formId: Number(argument.data.id),
            //       email: argument.data.storeifyInput_email,
            //       locale: argument.data.storeify_localization,
            //       currency: argument.data.storeify_currency,
            //       country: argument.data.storeify_country_code,
            //       products: argument.products,
            //       fields: argument.fields
            //     });
            // }else{
                window.dataLayer.push({
                    event: 'request_quote',
                    quoteId: Number(argument.id),
                    formId: Number(argument.data.id),
                    email: argument.data.storeifyInput_email,
                    locale: argument.data.storeify_localization,
                    currency: argument.data.storeify_currency,
                    country: argument.data.storeify_country_code,
                    products: argument.products,
                    fields: argument.fields ? Object.keys(argument.fields).map((key) => argument.fields[key]) : []// Array(argument.fields)
                 });
            // }
        }
        // Auto-detect và thêm GTM nếu có GTM ID trong meta tag hoặc biến global
        function autoAddGTM() {
          //// Tìm GTM ID trong meta tag
          // const metaGTM = document.querySelector('meta[name="gtm-id"]');
          // let ify_idGtm = metaGTM ? metaGTM.getAttribute('content') : null;
          let ify_idGtm = appConfig.ify_idGtm ? appConfig.ify_idGtm : null;

          // // Hoặc từ biến global window.GTM_ID
          // if (!ify_idGtm && window.GTM_ID) {
          //   ify_idGtm = window.GTM_ID;
          // }

          // // Hoặc từ Shopify settings (nếu có)
          // if (!ify_idGtm && typeof Shopify !== 'undefined' && Shopify.theme && Shopify.theme.settings) {
          //   ify_idGtm = Shopify.theme.settings.gtm_id;
          // }

          if (ify_idGtm) {
            addGTMWithShopifyEvents(ify_idGtm);
          } else {
            // console.log('Không tìm thấy GTM ID. Vui lòng gọi addGTMToShopify("GTM-XXXXXXX") manually.');
          }
        }

        // Chạy auto-detect khi DOM ready
        if (document.readyState === 'loading') {
          document.addEventListener('DOMContentLoaded', autoAddGTM);
        } else {
          autoAddGTM();
        }

        jQuery(document).on("submit", "form.storeify-form-action-quote", function (e) {
            if (e.isDefaultPrevented()) return;
            e.preventDefault();

            const $form = jQuery(this);
            
            var validator = $form.data('validator') || $form.validate();
            // LÚC NÀY MỚI CHỦ ĐỘNG KÍCH HOẠT VALIDATE
            if ($form.valid()) {
                // === KẾT QUẢ: ĐÚNG (VALID) ===

                // Chuyển đổi định dạng số điện thoại sang chuẩn E.164 trước khi gửi
                $(".storeify-input-phone").each(function () {
                    let iti = window.intlTelInput.getInstance(this);
                    let idInput = jQuery(this).attr('id');
                    if (iti && jQuery(this).val().trim() !== "") {
                        jQuery('#intl_' + idInput).val(iti.getNumber());
                    }
                });
                var id = $form.find('input[name="storeify_form_id"]').val();
                var key = $form.find('.captcha_side').val();
                // Same fix as storeify_contactform's shared extension asset
                // (storeifyRefreshCaptchaToken): the old query.then(success) with no
                // rejection handler meant a network hiccup reaching Google, an ad-blocker,
                // or grecaptcha simply never resolving left this Promise pending forever —
                // submitAjax() never ran, so no request went out and no loading state or
                // error ever appeared; the customer's click just did nothing. try/catch
                // around .execute() cannot catch that either, since a rejected Promise is
                // not a thrown exception. The timeout below guarantees the form still gets
                // submitted (server-side verification in RequestaquoteController::sendRequest
                // decides whether the token is acceptable), and the two-argument .then()
                // form catches an actual rejection the same way.
                if (window.grecaptcha && key != '' && typeof id !== "undefined" && jQuery('#g-recaptcha-response-' + id).length > 0) {
                    var storeifyCaptchaSettled = false;
                    var storeifyCaptchaProceed = function () {
                        if (storeifyCaptchaSettled) return;
                        storeifyCaptchaSettled = true;
                        submitAjax($form);
                    };
                    var storeifyCaptchaTimer = setTimeout(storeifyCaptchaProceed, 4000);
                    window.grecaptcha.ready(function () {
                        try {
                            window.grecaptcha.execute(key, {
                                action: 'validate_quote_captcha_' + id
                            }).then(function (token) {
                                document.getElementById('g-recaptcha-response-' + id).value = token;
                                document.getElementById('g-recaptcha-acction-' + id).value = 'validate_quote_captcha_' + id;
                                clearTimeout(storeifyCaptchaTimer);
                                storeifyCaptchaProceed();
                            }, function () {
                                clearTimeout(storeifyCaptchaTimer);
                                storeifyCaptchaProceed();
                            });
                        } catch (e) {
                            clearTimeout(storeifyCaptchaTimer);
                            storeifyCaptchaProceed();
                        }
                    });
                } else {
                    submitAjax($form);
                }

                // Tùy biến xử lý tiếp theo của bạn (ví dụ: gửi AJAX hoặc submit form)
                // $.ajax({ ... });

            } else {
                // === KẾT QUẢ: SAI (INVALID) ===
                // console.log("Form có lỗi. jQuery Validation lúc này mới hiển thị thông báo lỗi lên màn hình.");
            }
        });

        function customValidation(form_popup, id) {
            let validations = {};
            let validateRules = {};
            let validateMes = {};
            
            //add method email và phone

            let lang_required = '';
            let lang_email = '';

            if (typeof storeifyQuoteValidate !== 'undefined') {
                validations = storeifyQuoteValidate;
                if (typeof validations[id].rules !== 'undefined')
                    validateRules = validations[id].rules;
                if (typeof validations[id].mes !== 'undefined') {
                    //mes = validations[id].mes;
                    let validateMesLangData = Object.keys(validateMesLangIfy).length !== 0 && typeof validateMesLangIfy[id] !== 'undefined' ? validateMesLangIfy[id] : validations[id].mes;
                    jQuery.each(validateMesLangData, function (key, value) {
                        var itemMes = {};
                        jQuery.each(value, function (k, l) {
                            itemMes[k] = jQuery.validator.format(l);
                            if (k === 'required' && typeof storeify_lang.input_required !== "undefined" && storeify_lang.input_required && storeify_lang.input_required != null) {
                                itemMes[k] = storeify_lang.input_required;
                            }
                            if (k === 'email' && typeof storeify_lang.input_email !== "undefined" && storeify_lang.input_email && storeify_lang.input_email != null) {
                                itemMes[k] = storeify_lang.input_email;
                            }
                        });
                        validateMes[key] = itemMes;
                    });
                }
            }

            if (typeof appConfig.validateRules !== 'undefined') {
                validateRules = { ...validateRules, ...appConfig.validateRules };
            }
            if (typeof appConfig.validateMes !== 'undefined') {
                validateMes = { ...validateMes, ...appConfig.validateMes };
            }
            
            validateMes['ify_qty'] = {
                required: typeof storeify_lang.input_required !== "undefined" && storeify_lang.input_required !== '' && storeify_lang.input_required !== null ? storeify_lang.input_required : 'This field is required.',
                min: lang_qty_min,
                max: lang_qty_max
            }
            var existingDetailValidator = form_popup.data('validator');
            if (existingDetailValidator && typeof existingDetailValidator.destroy === 'function') {
                existingDetailValidator.destroy();
                form_popup.removeData('validator');
                form_popup.find('label.error').remove();
                form_popup.find('.error').removeClass('error');
            }
            form_popup.validate({
                onsubmit: false,    // Tắt tự động check khi form submit mặc định
                onfocusout: false,  // Tắt check khi người dùng rê chuột ra ngoài ô input (blur)
                onkeyup: false,     // Tắt check khi người dùng đang gõ phím
                rules: validateRules,
                messages: validateMes,
            });
        }

        // Hàm khởi tạo intl-tel-input cho các input số điện thoại
        function initIntlTelInputForStoreify(rootSelector) {
            if (typeof window.intlTelInput !== 'function') return;

            let $phoneInputs = jQuery(rootSelector).find('input.storeify-input-phone');
            // if (!$phoneInputs.length) return;

            let intlTelUtilsUrl = appConfig.intl_tel_utils_url || 'https://cdn.jsdelivr.net/npm/intl-tel-input@29.1.2/dist/js/utils.js';

            // 1. Lấy quốc gia mặc định từ Shopify làm fallback (trường hợp rớt mạng/lỗi API)
            let defaultCountry = (window.Shopify && window.Shopify.country)
                ? window.Shopify.country.toLowerCase()
                : 'us';
            let defaultLocale = typeof appConfig.request_iso_code !== 'undefined' && appConfig.request_iso_code
                ? appConfig.request_iso_code : window.Shopify.locale.toLowerCase();

            let url = "https://ipinfo.io/json";
            if (typeof appConfig.token_ipinfo !== 'undefined' && appConfig.token_ipinfo) {
                url = "https://ipinfo.io/json?token=" + appConfig.token_ipinfo;
            }
            let uiTranslations = typeof storeifyInterfaceTranslations !== "undefined" ? storeifyInterfaceTranslations : {};
            let countryTranslation = typeof storeifycountryNames !== "undefined" ? storeifycountryNames : {};
            $phoneInputs.each(function () {
                if (window.intlTelInput.getInstance(this)) return;
                let onlyCountries = this.getAttribute('data-country');
                if (typeof onlyCountries !== "undefined" && onlyCountries) {
                    onlyCountries = onlyCountries.split(',').map(c => c.trim().toLowerCase());
                }
                let itiInstance = window.intlTelInput(this, {
                    // 2. Cho phép dùng 'auto' khi đi kèm với initialCountryLookup
                    initialCountry: defaultCountry,
                    countryNameLocale: defaultLocale,
                    // uiTranslations: uiTranslations,
                    // 3. Sử dụng initialCountryLookup (Bắt buộc trả về một PROMISE)
                    // initialCountryLookup: () => {
                    //     return fetch(url)
                    //         .then(res => {
                    //             if (!res.ok) throw new Error("Network error");
                    //             return res.json();
                    //         })
                    //         .then(data => data.country ? data.country.toLowerCase() : defaultCountry)
                    //         .catch(() => defaultCountry);
                    // },
                    countryNameOverrides: countryTranslation || {},
                    onlyCountries: onlyCountries || null,
                    showFlags: true,
                    separateDialCode: true,
                    loadUtils: () => import(intlTelUtilsUrl)
                });

                if (itiInstance) {
                    jQuery(this).data('storeifyItiInstance', itiInstance);
                }
            });
            //add country
            let $countryInputs = jQuery(rootSelector).find('input.storeify-input-country');
            
            $countryInputs.each(function () {
                const fieldElement = this;
                let onlyCountries = fieldElement.getAttribute('data-country');
                if (typeof onlyCountries !== "undefined" && onlyCountries) {
                    onlyCountries = onlyCountries.split(',').map(c => c.trim().toLowerCase());
                }
                new SearchableCountrySelect(fieldElement, {
                    showDialCode: false, // Tắt hiển thị mã vùng nếu chỉ cần chọn quốc gia
                    defaultCountry: defaultCountry,
                    valueType: "name",//"iso2", 
                    countryNameLocale: defaultLocale,
                    countryNameOverrides: countryTranslation || {},
                    onlyCountries: onlyCountries || null,
                    inputSearchtext: typeof uiTranslations !== "undefined" && uiTranslations.searchPlaceholder ? uiTranslations.searchPlaceholder : "Search country"
                    // onChange: (selectedCountry, fieldName) => {
                    //     console.log(`[${fieldName}] changed to:`, selectedCountry);
                    // }
                });
            });
        }
        jQuery(document).on("input change", "form.storeify-form-action-quote input, form.storeify-form-action-quote select, textarea", function () {
            // .resetElements() là hàm chuẩn của jQuery Validation giúp xóa class lỗi và ẩn câu báo lỗi của đúng thẻ đang gõ

            // const formValidator = jQuery(this.form).validate();
            // // Xóa thông báo lỗi và viền đỏ của riêng ô đang gõ
            // if (formValidator) {
            //     formValidator.resetElements(jQuery(this));
            // }
            let idError = this.getAttribute('id') + '-error';
            document.querySelector('#' + idError)?.remove();
        });

        function addCustomMethod(Validator) {
            Validator.addClassRules("ify_price_input", {
                number: true
            });
            Validator.addClassRules("ify_qty_input", {
                number: true,
                required: true
            });
            Validator.addMethod("email", function (value, element) {
                return this.optional(element) || /^([a-zA-Z0-9!#$%&'*+\/=?^_`{|}~-]+(?:\.[a-zA-Z0-9!#$%&'*+\/=?^_`{|}~-]+)*@(?:[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?\.)+[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?)$/i.test(value);
            }, "Email Address is invalid: Please enter a valid email address.");
            Validator.addMethod("validPhone", function (value, element) {
                // 1. Lấy instance theo chuẩn v29.1 (Fallback về cách cũ nếu app Shopify dùng bản cũ)
                const iti = (window.intlTelInput && typeof window.intlTelInput.getInstance === "function" && window.intlTelInput.getInstance(element)) ||
                    (window.intlTelInputGlobals && window.intlTelInputGlobals.getInstance(element));
                // Nếu ô input trống hoặc không có instance -> nhường cho rule 'required' xử lý
                if (!iti || this.optional(element)) {
                    return true;
                }

                // 2. Bọc try...catch để CHỐNG CRASH khi utils.js bị App Storeify xung đột
                try {
                    // Trên v29.1, isValidNumber() trả về true | false | null
                    const valid = iti.isValidNumber();

                    // null nghĩa là chuỗi rỗng hoặc utils chưa sẵn sàng -> coi như hợp lệ (nhường cho required)
                    if (valid === null) return true;

                    return valid;
                } catch (err) {
                    console.warn("intl-tel-input v29.1: Xung đột utils.js với App Shopify trên element:", element.id, err);
                    // Khi bị xung đột từ App Shopify, fallback kiểm tra độ dài cơ bản (từ 8 đến 15 số theo chuẩn E.164)
                    const cleanNum = value.replace(/\D/g, "");
                    return cleanNum.length >= 8 && cleanNum.length <= 15;
                }
            }, "Please enter a valid phone number.");
        }

    }; //end storeifyJavaScript

    if (typeof jQuery == 'undefined' || typeof jQuery.fn.on == 'undefined') {
        loadScript('//code.jquery.com/jquery-3.4.1.min.js', function() {
            STOREIFY = jQuery.noConflict(true);
            STOREIFY(document).ready(function() {
                storeifyJavaScript(STOREIFY);
            });
        });
    } else {
        storeifyJavaScript(jQuery);
    }

})();